/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** Mongo ObjectId scalar type */
  ObjectId: any;
};

export type AchInstitution = {
  __typename?: 'ACHInstitution';
  id: Scalars['String'];
  isRTPEnabled: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type Account = {
  __typename?: 'Account';
  address?: Maybe<Scalars['String']>;
  balances?: Maybe<AccountBalance>;
  id: Scalars['ID'];
  owners: Array<Scalars['String']>;
  userId: Scalars['ObjectId'];
};

export type AccountBalance = {
  __typename?: 'AccountBalance';
  /** Address of controlling account */
  address: Scalars['String'];
  id: Scalars['ID'];
  protocols: Array<ProtocolBalance>;
  /** Total Balance in USD */
  total: Scalars['Float'];
};

export enum AccountProvider {
  Checkbook = 'CHECKBOOK',
  MethodFi = 'METHOD_FI',
  Plaid = 'PLAID'
}

export enum AccountType {
  Business = 'BUSINESS',
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type AddTransactionToPaymentInput = {
  directPaymentId: Scalars['String'];
  transactionHash: Scalars['String'];
};

export type AdminIssuePaymentInput = {
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  paymentProvider: PaymentProvider;
  userId: Scalars['String'];
};

export enum AppDomain {
  Quickswap = 'QUICKSWAP',
  Spritz = 'SPRITZ'
}

export type Bill = {
  __typename?: 'Bill';
  accountId: Scalars['String'];
  amountDue?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  canReceive: Scalars['Boolean'];
  connected: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  destinationAccountId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  institution?: Maybe<BillInstitution>;
  lastPaymentAmount?: Maybe<Scalars['Float']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  lastStatementBalance?: Maybe<Scalars['Float']>;
  lastSync?: Maybe<Scalars['DateTime']>;
  manual?: Maybe<Scalars['Boolean']>;
  mask?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nextPaymentDueDate?: Maybe<Scalars['DateTime']>;
  nextPaymentMinimumAmount?: Maybe<Scalars['Float']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  originalName: Scalars['String'];
  payments?: Maybe<Scalars['Int']>;
  provider: AccountProvider;
  remainingStatementBalance?: Maybe<Scalars['Float']>;
  syncStatus: BillSyncStatus;
  testPaymentAvailable: Scalars['Boolean'];
  type: BillType;
  user: User;
  userId: Scalars['ObjectId'];
  verified: Scalars['Boolean'];
};

export type BillInstitution = {
  __typename?: 'BillInstitution';
  id: Scalars['ID'];
  institutionId: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum BillSyncStatus {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Unavailable = 'UNAVAILABLE'
}

export enum BillType {
  AutoLoan = 'AUTO_LOAN',
  CreditCard = 'CREDIT_CARD',
  Loan = 'LOAN',
  MobilePhone = 'MOBILE_PHONE',
  Mortgage = 'MORTGAGE',
  StudentLoan = 'STUDENT_LOAN',
  Unknown = 'UNKNOWN',
  Utility = 'UTILITY'
}

export type CheckbookAccount = {
  __typename?: 'CheckbookAccount';
  accountNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  holder: Scalars['String'];
  id: Scalars['ID'];
  institution?: Maybe<AchInstitution>;
  institutionId?: Maybe<Scalars['ObjectId']>;
  isRTPEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  ownedByUser: Scalars['Boolean'];
  routingNumber?: Maybe<Scalars['String']>;
  type: AccountType;
  userId: Scalars['ObjectId'];
};

export type CheckbookAddress = {
  __typename?: 'CheckbookAddress';
  city: Scalars['String'];
  line_1: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type CheckbookNotifyFundingInput = {
  amount: Scalars['Float'];
  transmittalDate: Scalars['String'];
};

export type CheckbookPayment = {
  __typename?: 'CheckbookPayment';
  accountId: Scalars['ObjectId'];
  amount: Scalars['Float'];
  completionDate?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image_uri: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['Float'];
  paymentId: Scalars['ObjectId'];
  recipient: Scalars['String'];
  status: CheckbookPaymentStatus;
  userId: Scalars['ObjectId'];
};

export enum CheckbookPaymentStatus {
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  InProcess = 'IN_PROCESS',
  Mailed = 'MAILED',
  Paid = 'PAID',
  Printed = 'PRINTED',
  Queued = 'QUEUED',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID',
  Void = 'VOID'
}

export type CheckbookSendQueuedPaymentsInput = {
  forceACHFunding?: Maybe<Scalars['Boolean']>;
  numPaymentsLimit?: Maybe<Scalars['Int']>;
};

export type CheckbookUser = {
  __typename?: 'CheckbookUser';
  address: CheckbookAddress;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  userId: Scalars['ObjectId'];
};

export type CheckbookVirtualCard = {
  __typename?: 'CheckbookVirtualCard';
  balance: Scalars['Float'];
  externalId: Scalars['String'];
  holderDetails: CheckbookUser;
  id: Scalars['ID'];
  mask: Scalars['String'];
  renderSecret: Scalars['String'];
  userId: Scalars['ObjectId'];
};

export type CircleBalances = {
  __typename?: 'CircleBalances';
  available: Scalars['Float'];
  unsettled: Scalars['Float'];
};

export type CognitoKycFlow = {
  __typename?: 'CognitoKycFlow';
  completed_at?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  id: Scalars['ID'];
  shareable_url?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  template: CognitoKycFlowTemplate;
  userCompleted: Scalars['Boolean'];
  userId: Scalars['ObjectId'];
};

export type CognitoKycFlowTemplate = {
  __typename?: 'CognitoKycFlowTemplate';
  id: Scalars['ID'];
  version: Scalars['Int'];
};

export type CreateAccountInput = {
  accountNumber: Scalars['String'];
  email: Scalars['String'];
  holder: Scalars['String'];
  name: Scalars['String'];
  ownedByUser?: Maybe<Scalars['Boolean']>;
  routingNumber: Scalars['String'];
  type: AccountType;
};

export type CreateDirectPaymentInput = {
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  network?: Maybe<Scalars['String']>;
  provider?: Maybe<AccountProvider>;
  /** The amount of rewards balance to apply to the payment */
  rewardsAmount?: Maybe<Scalars['Float']>;
  subscriptionId?: Maybe<Scalars['String']>;
  /** Whether to apply testPayment rewards */
  testPayment?: Maybe<Scalars['Boolean']>;
  tokenAddress?: Maybe<Scalars['String']>;
};

export type CreatePaymentInstructionInput = {
  accountDescription?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  amount?: Maybe<Scalars['Float']>;
  amountType: PaymentAmountType;
  deliveryDateType: DeliveryDateType;
  deliveryDaysBefore?: Maybe<Scalars['Int']>;
  deliveryExactDate?: Maybe<Scalars['DateTime']>;
  institution?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentFrequency: PaymentFrequency;
  provider?: Maybe<AccountProvider>;
};

export type CreateSubscriptionInput = {
  accountId: Scalars['String'];
  amount?: Maybe<Scalars['Float']>;
  frequency: SubscriptionFrequency;
  frequencyValue?: Maybe<Scalars['Int']>;
  network?: Maybe<Scalars['String']>;
  paymentToken: Scalars['String'];
  provider: AccountProvider;
  signedMessage?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  tokenSymbol: Scalars['String'];
  totalPayments?: Maybe<Scalars['Int']>;
  type: SubscriptionType;
  walletAddress: Scalars['String'];
};

/** Fields to create new userClient by admin */
export type CreateUserInput = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CreateVerifiedAccountInput = {
  address: Scalars['String'];
  message: Scalars['String'];
  signedMessage: Scalars['String'];
};


export enum DeliveryDateType {
  DueDate = 'DUE_DATE',
  ExactDate = 'EXACT_DATE',
  NumDaysBefore = 'NUM_DAYS_BEFORE'
}

export type DirectPayment = {
  __typename?: 'DirectPayment';
  account: PayableAccount;
  accountId: Scalars['ObjectId'];
  amount: Scalars['Float'];
  amountDue: Scalars['Float'];
  bill?: Maybe<Bill>;
  createdAt: Scalars['DateTime'];
  currentTime?: Maybe<Scalars['DateTime']>;
  feeAmount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  network: Scalars['String'];
  paymentId: Scalars['ObjectId'];
  provider: AccountProvider;
  rewardsAmount?: Maybe<Scalars['Float']>;
  status: DirectPaymentStatus;
  subscriptionId?: Maybe<Scalars['ObjectId']>;
  testPayment?: Maybe<Scalars['Boolean']>;
  toAddress: Scalars['String'];
  tokenAddress: Scalars['String'];
  totalAmount: Scalars['Float'];
  transactionReferences: Array<DirectPaymentTransactionReference>;
  user: User;
  userId: Scalars['ObjectId'];
};

export enum DirectPaymentStatus {
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  TransactionFailed = 'TRANSACTION_FAILED',
  TransactionPending = 'TRANSACTION_PENDING'
}

export type DirectPaymentTransactionReference = {
  __typename?: 'DirectPaymentTransactionReference';
  asset?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  hash: Scalars['String'];
  network: Scalars['String'];
  paymentToken?: Maybe<PaymentEventToken>;
  sourceToken?: Maybe<PaymentEventToken>;
  status: DirectPaymentTransactionReferenceStatus;
  to?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export enum DirectPaymentTransactionReferenceStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export type ExternalPayment = {
  __typename?: 'ExternalPayment';
  amount: Scalars['Float'];
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  errorReason?: Maybe<Scalars['String']>;
  estimatedCompletionDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  paymentProvider: PaymentProvider;
  status: PaymentStatus;
};

export type GasPrice = {
  __typename?: 'GasPrice';
  lastBlock: Scalars['Float'];
  network: Network;
  speeds: GasSpeed;
  timestamp: Scalars['String'];
};

export type GasSpeed = {
  __typename?: 'GasSpeed';
  fast?: Maybe<Scalars['Float']>;
  instant?: Maybe<Scalars['Float']>;
  standard?: Maybe<Scalars['Float']>;
};

export type GrowsurfParticipant = {
  __typename?: 'GrowsurfParticipant';
  email: Scalars['String'];
  fraudRiskLevel: Scalars['String'];
  id: Scalars['ID'];
  impressionCount: Scalars['Float'];
  monthlyReferralCount: Scalars['Float'];
  prevMonthlyReferralCount: Scalars['Float'];
  referralCount: Scalars['Float'];
  referralSource: Scalars['String'];
  referralStatus?: Maybe<Scalars['String']>;
  referredBy?: Maybe<Scalars['String']>;
  referrer?: Maybe<GrowsurfParticipant>;
  shareCount: Scalars['Float'];
  shareUrl: Scalars['String'];
  uniqueImpressionCount: Scalars['Float'];
  userId: Scalars['ObjectId'];
  vanityKeys: Array<Scalars['String']>;
};

export type GrowsurfReferralStats = {
  __typename?: 'GrowsurfReferralStats';
  id: Scalars['ID'];
  /** Number of qualified referrals, having paid bills */
  qualifiedReferrals: Scalars['Float'];
  /** Dollar amount earned from referrals */
  rewardsEarned: Scalars['Float'];
  /** Number of users signed up from this user's referrals */
  signups: Scalars['Float'];
};

export type KycStatus = {
  __typename?: 'KycStatus';
  cognitoKycFlow?: Maybe<CognitoKycFlow>;
  id: Scalars['ID'];
  signature: Scalars['String'];
};

export type MercuryAccountInfo = {
  __typename?: 'MercuryAccountInfo';
  accountNumber: Scalars['String'];
  availableBalance: Scalars['Float'];
  canReceiveTransactions?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  currentBalance: Scalars['Float'];
  id: Scalars['String'];
  kind: Scalars['String'];
  name: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  routingNumber: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type MercuryTransaction = {
  __typename?: 'MercuryTransaction';
  amount: Scalars['Float'];
  bankDescription?: Maybe<Scalars['String']>;
  counterpartyId?: Maybe<Scalars['String']>;
  counterpartyName?: Maybe<Scalars['String']>;
  counterpartyNickname?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']>;
  externalMemo?: Maybe<Scalars['String']>;
  feeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  postedAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
};

export type MethodFiAchPull = {
  __typename?: 'MethodFiACHPull';
  amount: Scalars['Float'];
  effective_date: Scalars['String'];
};

export type MethodFiAccount = {
  __typename?: 'MethodFiAccount';
  ach: MethodFiAch;
  available_capabilities: Array<Scalars['String']>;
  capabilities: Array<Scalars['String']>;
  connected?: Maybe<Scalars['Boolean']>;
  holder_id: Scalars['String'];
  id: Scalars['ID'];
  institution?: Maybe<MethodFiMerchant>;
  integrationId?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  liability?: Maybe<MethodFiLiability>;
  manual?: Maybe<Scalars['Boolean']>;
  nickname?: Maybe<Scalars['String']>;
  payment_status?: Maybe<Scalars['String']>;
  payments?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  type: Scalars['String'];
  userId: Scalars['ObjectId'];
};

export type MethodFiAch = {
  __typename?: 'MethodFiAch';
  number: Scalars['String'];
  routing: Scalars['String'];
  type: Scalars['String'];
};

export type MethodFiAddress = {
  __typename?: 'MethodFiAddress';
  city?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MethodFiEntity = {
  __typename?: 'MethodFiEntity';
  active: Scalars['Boolean'];
  address?: Maybe<MethodFiAddress>;
  authenticated: Scalars['Boolean'];
  available_capabilities: Array<Scalars['String']>;
  canReceive: Scalars['Boolean'];
  canRetrieveData: Scalars['Boolean'];
  capabilities: Array<Scalars['String']>;
  connectionId?: Maybe<Scalars['String']>;
  corporation?: Maybe<MethodFiEntityCorporation>;
  createdAt: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  individual?: Maybe<MethodFiEntityIndividual>;
  locked: Scalars['Boolean'];
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ObjectId'];
};

export type MethodFiEntityCorporation = {
  __typename?: 'MethodFiEntityCorporation';
  dba?: Maybe<Scalars['String']>;
  ein?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owners: Array<MethodFiEntityIndividual>;
};

export type MethodFiEntityIndividual = {
  __typename?: 'MethodFiEntityIndividual';
  address?: Maybe<MethodFiAddress>;
  dob?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type MethodFiError = {
  __typename?: 'MethodFiError';
  code: Scalars['Float'];
  message: Scalars['String'];
  sub_type: Scalars['String'];
  type: Scalars['String'];
};

export type MethodFiLiability = {
  __typename?: 'MethodFiLiability';
  balance?: Maybe<Scalars['Float']>;
  lastPaymentAmount?: Maybe<Scalars['Float']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  lastStatementBalance?: Maybe<Scalars['Float']>;
  lastSync?: Maybe<Scalars['DateTime']>;
  mask?: Maybe<Scalars['String']>;
  mch_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  nextPaymentDueDate?: Maybe<Scalars['DateTime']>;
  nextPaymentMinimumAmount?: Maybe<Scalars['Float']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  remainingStatementBalance?: Maybe<Scalars['Float']>;
  subType?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type MethodFiMerchant = {
  __typename?: 'MethodFiMerchant';
  accountCount?: Maybe<Scalars['Int']>;
  accountPrefixes: Array<Scalars['String']>;
  averagePaymentTiming?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  parentName: Scalars['String'];
  paymentsSent: Scalars['Int'];
  types: Array<Scalars['String']>;
};

export type MethodFiReversal = {
  __typename?: 'MethodFiReversal';
  amount: Scalars['Float'];
  created_at: Scalars['String'];
  description: Scalars['String'];
  direction: Scalars['String'];
  error?: Maybe<MethodFiError>;
  id: Scalars['ID'];
  methodFiPaymentId: Scalars['ObjectId'];
  pmt_id: Scalars['String'];
  status: Scalars['String'];
  target_account: Scalars['String'];
  trace_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  userId: Scalars['ObjectId'];
};

export type MethodFiWebhook = {
  __typename?: 'MethodFiWebhook';
  created_at: Scalars['String'];
  id: Scalars['ID'];
  type: Scalars['String'];
  updated_at: Scalars['String'];
  url: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAccount: MethodFiAccount;
  addAffiliateReferralCode: Scalars['Boolean'];
  addAssociatedWallet: Scalars['Boolean'];
  /** @deprecated No longer used */
  addTransactionToDirectPayment: DirectPayment;
  adminCreateDirectPayment: DirectPayment;
  adminIssuePayment?: Maybe<Payment>;
  approvePaymentReversal: Scalars['Boolean'];
  cancelPaymentInstruction: PaymentInstruction;
  checkbookNotifyFunding: Scalars['Boolean'];
  checkbookSendQueuedPayments?: Maybe<Array<CheckbookPayment>>;
  connectBills: Scalars['Boolean'];
  createCheckbookAccount: CheckbookAccount;
  createDirectPayment: DirectPayment;
  createGrowsurfParticipant?: Maybe<GrowsurfParticipant>;
  createPaymentInstruction: PaymentInstruction;
  createSpritzSourceAccount: MethodFiAccount;
  createSubscription: PaymentSubscription;
  createUser: User;
  /** @deprecated User should createVerifiedAccount */
  createUserAccount: Scalars['Boolean'];
  createVerifiedAccount: Scalars['Boolean'];
  createVirtualCard: CheckbookVirtualCard;
  deleteBill: Scalars['Boolean'];
  deleteCheckbookAccount: CheckbookAccount;
  deleteDirectPayment: Scalars['Boolean'];
  deleteSubscription: Scalars['Boolean'];
  disconnectBill: Scalars['Boolean'];
  flushBalances: Array<TokenBalance>;
  forcePayment: Payment;
  grantCredit: RewardTransaction;
  kycStatusSetUserCompleted: KycStatus;
  /** @deprecated User should createVerifiedAccount */
  linkAccountToUser: Account;
  lockEntityAuth: MethodFiEntity;
  markNotificationAsRead?: Maybe<UserNotification>;
  methodFiUpdateSSN: MethodFiEntity;
  refreshEntities: Scalars['Boolean'];
  refundPayment: Payment;
  removePlaidAccount: Scalars['Boolean'];
  renameBill: Bill;
  renameCheckbookAccount: CheckbookAccount;
  resetEntity: Scalars['Boolean'];
  resyncAccounts: Scalars['Boolean'];
  resyncEntityAccounts: Scalars['Boolean'];
  retrySubscriptionCharge: Scalars['Boolean'];
  savePlaidAccount: PlaidAccount;
  simulatePaymentUpdate: Scalars['Boolean'];
  submitSecurityQuestions: Array<SecurityQuestion>;
  updateAppDomain: Scalars['Boolean'];
  updateAttributionSource?: Maybe<User>;
  updateBillType: Bill;
  updateCurrentUser: User;
  updateEntityAuthentication?: Maybe<MethodFiEntity>;
  updateOnboardingStatus: User;
  updateUserTimezone: User;
  verifyPlaidAccounts: Scalars['Boolean'];
};


export type MutationAddAccountArgs = {
  accountId: Scalars['String'];
  merchantId: Scalars['String'];
  type?: Maybe<BillType>;
};


export type MutationAddAffiliateReferralCodeArgs = {
  referralCode: Scalars['String'];
};


export type MutationAddAssociatedWalletArgs = {
  address: Scalars['String'];
};


export type MutationAddTransactionToDirectPaymentArgs = {
  addTransactionToPaymentInput: AddTransactionToPaymentInput;
};


export type MutationAdminCreateDirectPaymentArgs = {
  createDirectPaymentInput: CreateDirectPaymentInput;
  userId: Scalars['String'];
};


export type MutationAdminIssuePaymentArgs = {
  issuePaymentInput: AdminIssuePaymentInput;
};


export type MutationApprovePaymentReversalArgs = {
  paymentId: Scalars['String'];
};


export type MutationCancelPaymentInstructionArgs = {
  paymentInstructionId: Scalars['String'];
};


export type MutationCheckbookNotifyFundingArgs = {
  notifyFundingInput: CheckbookNotifyFundingInput;
};


export type MutationCheckbookSendQueuedPaymentsArgs = {
  checkbookSendQueuedPaymentsInput?: Maybe<CheckbookSendQueuedPaymentsInput>;
};


export type MutationConnectBillsArgs = {
  accountIds: Array<Scalars['String']>;
};


export type MutationCreateCheckbookAccountArgs = {
  createAccountInput: CreateAccountInput;
};


export type MutationCreateDirectPaymentArgs = {
  createDirectPaymentInput: CreateDirectPaymentInput;
};


export type MutationCreateGrowsurfParticipantArgs = {
  referrerId?: Maybe<Scalars['String']>;
};


export type MutationCreatePaymentInstructionArgs = {
  createPaymentInstructionInput: CreatePaymentInstructionInput;
};


export type MutationCreateSubscriptionArgs = {
  createSubscriptionInput: CreateSubscriptionInput;
  signatureParams?: Maybe<SignatureParamsInput>;
};


export type MutationCreateUserArgs = {
  createUser: CreateUserInput;
};


export type MutationCreateUserAccountArgs = {
  address: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationCreateVerifiedAccountArgs = {
  createVerifiedAccountInput: CreateVerifiedAccountInput;
};


export type MutationDeleteBillArgs = {
  accountId: Scalars['String'];
  provider?: Maybe<AccountProvider>;
};


export type MutationDeleteCheckbookAccountArgs = {
  accountId: Scalars['String'];
};


export type MutationDeleteDirectPaymentArgs = {
  directPaymentId: Scalars['String'];
};


export type MutationDeleteSubscriptionArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationDisconnectBillArgs = {
  accountId: Scalars['String'];
  provider?: Maybe<AccountProvider>;
};


export type MutationFlushBalancesArgs = {
  addresses: Array<Scalars['String']>;
};


export type MutationForcePaymentArgs = {
  paymentId: Scalars['String'];
};


export type MutationGrantCreditArgs = {
  amount: Scalars['Float'];
  userId: Scalars['String'];
};


export type MutationLinkAccountToUserArgs = {
  address: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['String'];
};


export type MutationMethodFiUpdateSsnArgs = {
  ssn: Scalars['String'];
};


export type MutationRefundPaymentArgs = {
  refundPaymentInput: RefundPaymentInput;
};


export type MutationRemovePlaidAccountArgs = {
  accountId: Scalars['String'];
};


export type MutationRenameBillArgs = {
  accountId: Scalars['String'];
  name: Scalars['String'];
  provider?: Maybe<AccountProvider>;
};


export type MutationRenameCheckbookAccountArgs = {
  accountId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationResetEntityArgs = {
  userId: Scalars['String'];
};


export type MutationResyncEntityAccountsArgs = {
  entityId: Scalars['String'];
};


export type MutationRetrySubscriptionChargeArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationSavePlaidAccountArgs = {
  savePlaidAccountInput: SavePlaidAccountInput;
};


export type MutationSimulatePaymentUpdateArgs = {
  paymentId: Scalars['String'];
  status: Scalars['String'];
};


export type MutationSubmitSecurityQuestionsArgs = {
  submission: Array<SubmitSecurityQuestionsInput>;
};


export type MutationUpdateAppDomainArgs = {
  appDomain: AppDomain;
};


export type MutationUpdateAttributionSourceArgs = {
  attributionSource: Scalars['String'];
};


export type MutationUpdateBillTypeArgs = {
  accountId: Scalars['String'];
  provider?: Maybe<AccountProvider>;
  type: BillType;
};


export type MutationUpdateCurrentUserArgs = {
  userUpdate: UpdateCurrentUserInput;
};


export type MutationUpdateEntityAuthenticationArgs = {
  connectionId?: Maybe<Scalars['String']>;
};


export type MutationUpdateOnboardingStatusArgs = {
  status: OnboardingStatus;
};


export type MutationUpdateUserTimezoneArgs = {
  timezone: Scalars['String'];
};

export enum Network {
  Arbitrum = 'Arbitrum',
  Avalanche = 'Avalanche',
  Binance = 'Binance',
  Celo = 'Celo',
  Ethereum = 'Ethereum',
  Fantom = 'Fantom',
  Gnosis = 'Gnosis',
  Harmony = 'Harmony',
  Moonriver = 'Moonriver',
  Optimism = 'Optimism',
  Polygon = 'Polygon'
}


export enum OnboardingStatus {
  Completed = 'COMPLETED',
  Legacy = 'LEGACY',
  NotShown = 'NOT_SHOWN',
  NotStarted = 'NOT_STARTED',
  Skipped = 'SKIPPED'
}

export type Pagination = {
  limit?: Maybe<Scalars['Float']>;
  offset?: Maybe<Scalars['Float']>;
};

export type PayableAccount = {
  __typename?: 'PayableAccount';
  accountProvider: AccountProvider;
  id: Scalars['ID'];
  name: Scalars['String'];
  ownedByUser: Scalars['Boolean'];
  paymentProvider: PaymentProvider;
  subType?: Maybe<BillType>;
  type: PayableAccountType;
};

export enum PayableAccountType {
  BankAccount = 'BANK_ACCOUNT',
  Bill = 'BILL',
  PayOthers = 'PAY_OTHERS',
  SpritzCard = 'SPRITZ_CARD'
}

export type Payment = {
  __typename?: 'Payment';
  account?: Maybe<PayableAccount>;
  accountId?: Maybe<Scalars['ObjectId']>;
  amount?: Maybe<Scalars['Float']>;
  bill?: Maybe<Bill>;
  createdAt: Scalars['DateTime'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  directPayment?: Maybe<DirectPayment>;
  directPaymentId?: Maybe<Scalars['ObjectId']>;
  externalPayment?: Maybe<ExternalPayment>;
  externalPaymentId?: Maybe<Scalars['ObjectId']>;
  feeAmount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  paymentDestination?: Maybe<PaymentDestination>;
  paymentInstruction?: Maybe<PaymentInstruction>;
  paymentInstructionId?: Maybe<Scalars['ObjectId']>;
  paymentProvider: PaymentProvider;
  refund?: Maybe<PaymentRefund>;
  rewardsAmount?: Maybe<Scalars['Float']>;
  rewardsTransaction?: Maybe<Scalars['ObjectId']>;
  status: PaymentStatus;
  subscriptionId?: Maybe<Scalars['ObjectId']>;
  type: Scalars['String'];
  user: User;
  userId: Scalars['ObjectId'];
};

export enum PaymentAmountType {
  BalanceDue = 'BALANCE_DUE',
  ExactAmount = 'EXACT_AMOUNT',
  MinimumDue = 'MINIMUM_DUE',
  PaymentDue = 'PAYMENT_DUE',
  StatementBalance = 'STATEMENT_BALANCE',
  UpToAmount = 'UP_TO_AMOUNT'
}

export type PaymentDestination = CheckbookAccount | CheckbookVirtualCard | MethodFiAccount;

export type PaymentEventToken = {
  __typename?: 'PaymentEventToken';
  address: Scalars['String'];
  amount: Scalars['Float'];
  amountRaw: Scalars['String'];
  decimals: Scalars['Float'];
  symbol: Scalars['String'];
};

/** How often the payment is made */
export enum PaymentFrequency {
  OneTime = 'ONE_TIME',
  RecurringMonthly = 'RECURRING_MONTHLY'
}

export type PaymentInstruction = {
  __typename?: 'PaymentInstruction';
  accountDescription?: Maybe<Scalars['String']>;
  accountId: Scalars['ObjectId'];
  amount?: Maybe<Scalars['Float']>;
  amountType: PaymentAmountType;
  bill?: Maybe<Bill>;
  deliveryDateType: DeliveryDateType;
  deliveryDaysBefore?: Maybe<Scalars['Int']>;
  deliveryExactDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  institution?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentFrequency: PaymentFrequency;
  plaidAccount?: Maybe<PlaidAccount>;
  provider: AccountProvider;
  status: PaymentInstructionStatus;
  userId: Scalars['ObjectId'];
};

export enum PaymentInstructionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED'
}

export type PaymentLimits = {
  __typename?: 'PaymentLimits';
  absolute: Scalars['Float'];
  delay: Scalars['Float'];
};

export type PaymentLimitsInput = {
  accountId: Scalars['String'];
  type: Scalars['String'];
};

export enum PaymentProvider {
  Checkbook = 'CHECKBOOK',
  MethodFi = 'METHOD_FI'
}

export type PaymentRefund = {
  __typename?: 'PaymentRefund';
  amount: Scalars['Float'];
  hash?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export enum PaymentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  ReversalInProgress = 'REVERSAL_IN_PROGRESS',
  Reversed = 'REVERSED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export type PaymentSubscription = {
  __typename?: 'PaymentSubscription';
  accountId: Scalars['ObjectId'];
  amount?: Maybe<Scalars['Float']>;
  blockchainSubscriptionId?: Maybe<Scalars['String']>;
  error?: Maybe<SubscriptionError>;
  frequency: SubscriptionFrequency;
  frequencyValue: Scalars['Int'];
  id: Scalars['ID'];
  network: Scalars['String'];
  nextSubscriptionDate?: Maybe<Scalars['DateTime']>;
  paymentToken?: Maybe<Scalars['String']>;
  processing: Scalars['Boolean'];
  provider: AccountProvider;
  signatureParams?: Maybe<SubscriptionSignatureParams>;
  signedMessage?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  subscriptionCount: Scalars['Int'];
  tokenSymbol?: Maybe<Scalars['String']>;
  totalPayments: Scalars['Int'];
  type: SubscriptionType;
  user: User;
  userId: Scalars['ObjectId'];
  walletAddress?: Maybe<Scalars['String']>;
};

export enum PaymentType {
  DirectPayment = 'DIRECT_PAYMENT',
  ScheduledPayment = 'SCHEDULED_PAYMENT'
}

export type PaymentsFilter = {
  accountId?: Maybe<Scalars['ObjectId']>;
  paymentId?: Maybe<Scalars['String']>;
  paymentProvider?: Maybe<PaymentProvider>;
  status?: Maybe<Array<PaymentStatus>>;
  type?: Maybe<PaymentType>;
};

export type PlaidAccount = {
  __typename?: 'PlaidAccount';
  accountId: Scalars['String'];
  balance?: Maybe<PlaidAccountBalance>;
  id: Scalars['ID'];
  institution?: Maybe<PlaidInstitution>;
  /** @deprecated Replaced by institution */
  institutionId: Scalars['String'];
  /** @deprecated Replaced by institution */
  institutionName: Scalars['String'];
  itemId?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  liability?: Maybe<PlaidAccountLiability>;
  mask?: Maybe<Scalars['String']>;
  methodFiAccountId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  officialName?: Maybe<Scalars['String']>;
  subType?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  userId: Scalars['ObjectId'];
};

export type PlaidAccountBalance = {
  __typename?: 'PlaidAccountBalance';
  available?: Maybe<Scalars['Float']>;
  currencyCode: Scalars['String'];
  current?: Maybe<Scalars['Float']>;
  limit?: Maybe<Scalars['Float']>;
};

export type PlaidAccountLiability = {
  __typename?: 'PlaidAccountLiability';
  lastPaymentAmount?: Maybe<Scalars['Float']>;
  lastPaymentDate?: Maybe<Scalars['String']>;
  lastStatementBalance?: Maybe<Scalars['Float']>;
  minPaymentAmount?: Maybe<Scalars['Float']>;
  nextPaymentAmount?: Maybe<Scalars['Float']>;
  nextPaymentDate?: Maybe<Scalars['String']>;
  overdue?: Maybe<Scalars['Boolean']>;
};

export type PlaidInstitution = {
  __typename?: 'PlaidInstitution';
  color: Scalars['String'];
  id: Scalars['ID'];
  institution_id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type PopularBill = {
  __typename?: 'PopularBill';
  count: Scalars['Int'];
  id: Scalars['ID'];
  institution: BillInstitution;
  merchantId: Scalars['String'];
  name: Scalars['String'];
  type: BillType;
};

export type ProtocolBalance = {
  __typename?: 'ProtocolBalance';
  /** Address of controlling account */
  address: Scalars['String'];
  /** JSON-encoded details */
  details: Scalars['String'];
  id: Scalars['ID'];
  network: Scalars['String'];
  /** Protocol Name */
  protocolName: Scalars['String'];
  /** Total balance in USD */
  total: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  achInstitution?: Maybe<AchInstitution>;
  activeBills: Array<Bill>;
  adminDirectPayment?: Maybe<DirectPayment>;
  adminDirectPayments: Array<DirectPayment>;
  adminPayments: Array<Payment>;
  adminPaymentsCount: Scalars['Int'];
  adminRecentPayments: Array<Payment>;
  adminTransactionPrice: Scalars['Float'];
  bankAccounts: Array<CheckbookAccount>;
  bills: Array<Bill>;
  checkbookPrefundedAccountBalance?: Maybe<Scalars['Float']>;
  circleBalances: CircleBalances;
  directPayment?: Maybe<DirectPayment>;
  directPayments: Array<DirectPayment>;
  findByWalletAddress: Array<User>;
  gasPrice?: Maybe<GasPrice>;
  /** @deprecated Replaced by account */
  getAccount?: Maybe<Account>;
  /** @deprecated Replaced by me */
  getCurrentUser: User;
  getMethodFiAuthToken?: Maybe<Scalars['String']>;
  getPayableAccounts: Array<PayableAccount>;
  getPlaidAccounts: Array<PlaidAccount>;
  getPlaidAccountsForUser: Array<PlaidAccount>;
  getPlaidLinkToken: Scalars['String'];
  getSpritzSourceAccount?: Maybe<MethodFiAccount>;
  getUser: User;
  getUserAccount?: Maybe<Account>;
  getUsers: Array<User>;
  growsurfParticipant?: Maybe<GrowsurfParticipant>;
  growsurfSecret?: Maybe<Scalars['String']>;
  hasBillPayPayments: Scalars['Boolean'];
  hasPayments: Scalars['Boolean'];
  me: User;
  merchants: Array<MethodFiMerchant>;
  mercuryAccountInfo: MercuryAccountInfo;
  mercuryAccounts: Array<MercuryAccountInfo>;
  mercuryTransactions: Array<MercuryTransaction>;
  methodFiACHReport: Array<MethodFiAchPull>;
  methodFiEntity?: Maybe<MethodFiEntity>;
  methodFiWebhooks: Array<MethodFiWebhook>;
  notifications: Array<UserNotification>;
  outstandingDirectPayments: Array<DirectPayment>;
  paymentByExternalId: Payment;
  paymentHistory: Array<Payment>;
  paymentInstructions: Array<PaymentInstruction>;
  paymentLimits: PaymentLimits;
  payments: Array<Payment>;
  paymentsInProgress: Array<Payment>;
  pendingActivationBills: Array<Bill>;
  popularBills: Array<PopularBill>;
  popularMerchants: Array<MethodFiMerchant>;
  recurringPaymentInstructions: Array<PaymentInstruction>;
  referralStats?: Maybe<GrowsurfReferralStats>;
  reversals: MethodFiReversal;
  rewardsBalance: Scalars['Float'];
  rewardTransactions: Array<RewardTransaction>;
  scheduledPayments: Array<Payment>;
  sdkConfig: Array<Scalars['String']>;
  securityQuestions: Array<SecurityQuestion>;
  subscriptions: Array<PaymentSubscription>;
  tokenBalances: Array<TokenBalance>;
  totalTokenBalance: Scalars['Float'];
  transactionPrice: Scalars['Float'];
  transactions: Array<Transaction>;
  transactionVolume: Scalars['Float'];
  /** @deprecated use paymentsInProgress */
  upcomingPayments: Array<Payment>;
  userBills: Array<Bill>;
  userPayment: Payment;
  userPaymentInstructions: Array<PaymentInstruction>;
  userPayments: Array<Payment>;
  userUpcomingPayments: Array<Payment>;
  validateReferralCode: Scalars['Boolean'];
  virtualCard?: Maybe<CheckbookVirtualCard>;
  virtualCards: Array<CheckbookVirtualCard>;
};


export type QueryAchInstitutionArgs = {
  routingNumber: Scalars['String'];
};


export type QueryAdminDirectPaymentArgs = {
  directPaymentId: Scalars['String'];
};


export type QueryAdminDirectPaymentsArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type QueryAdminPaymentsArgs = {
  filter?: Maybe<PaymentsFilter>;
  pagination?: Maybe<Pagination>;
  userId?: Maybe<Scalars['String']>;
};


export type QueryAdminPaymentsCountArgs = {
  filter?: Maybe<PaymentsFilter>;
  userId?: Maybe<Scalars['String']>;
};


export type QueryAdminRecentPaymentsArgs = {
  userId: Scalars['String'];
};


export type QueryAdminTransactionPriceArgs = {
  amount: Scalars['Float'];
  userId: Scalars['String'];
};


export type QueryBankAccountsArgs = {
  ownedByUser?: Maybe<Scalars['Boolean']>;
};


export type QueryDirectPaymentArgs = {
  paymentId: Scalars['String'];
};


export type QueryFindByWalletAddressArgs = {
  address: Scalars['String'];
};


export type QueryGasPriceArgs = {
  network: Scalars['String'];
};


export type QueryGetPayableAccountsArgs = {
  accountIds: Array<Scalars['String']>;
};


export type QueryGetPlaidAccountsForUserArgs = {
  userId: Scalars['String'];
};


export type QueryGetUserArgs = {
  userId: Scalars['String'];
};


export type QueryGetUserAccountArgs = {
  userId: Scalars['String'];
};


export type QueryGetUsersArgs = {
  searchText?: Maybe<Scalars['String']>;
};


export type QueryMerchantsArgs = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<BillType>;
};


export type QueryMercuryTransactionsArgs = {
  accountId?: Maybe<Scalars['String']>;
};


export type QueryOutstandingDirectPaymentsArgs = {
  accountId?: Maybe<Scalars['String']>;
};


export type QueryPaymentByExternalIdArgs = {
  externalId: Scalars['String'];
};


export type QueryPaymentLimitsArgs = {
  paymentLimitsInput: PaymentLimitsInput;
};


export type QueryPaymentsArgs = {
  filter?: Maybe<PaymentsFilter>;
};


export type QueryPopularMerchantsArgs = {
  type?: Maybe<BillType>;
};


export type QueryTokenBalancesArgs = {
  address: Scalars['String'];
  network?: Maybe<Scalars['String']>;
};


export type QueryTotalTokenBalanceArgs = {
  address: Scalars['String'];
  networks?: Maybe<Array<Network>>;
};


export type QueryTransactionPriceArgs = {
  amount: Scalars['Float'];
};


export type QueryTransactionsArgs = {
  address: Scalars['String'];
};


export type QueryUserBillsArgs = {
  userId: Scalars['String'];
};


export type QueryUserPaymentArgs = {
  paymentId: Scalars['String'];
};


export type QueryUserPaymentInstructionsArgs = {
  userId: Scalars['String'];
};


export type QueryUserPaymentsArgs = {
  userId: Scalars['String'];
};


export type QueryUserUpcomingPaymentsArgs = {
  userId: Scalars['String'];
};


export type QueryValidateReferralCodeArgs = {
  referralCode: Scalars['String'];
};

export type RawContract = {
  __typename?: 'RawContract';
  address?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Float']>;
  rawValue?: Maybe<Scalars['String']>;
};

export type RefundPaymentInput = {
  amount: Scalars['Float'];
  paymentId: Scalars['String'];
  to?: Maybe<Scalars['String']>;
  transactionHash?: Maybe<Scalars['String']>;
};

export enum RewardCreditSource {
  ReferralReward = 'REFERRAL_REWARD',
  Refund = 'REFUND'
}

export type RewardTransaction = {
  __typename?: 'RewardTransaction';
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  paymentId?: Maybe<Scalars['ObjectId']>;
  source?: Maybe<RewardCreditSource>;
  type: RewardTransactionType;
  userId: Scalars['ObjectId'];
};

export enum RewardTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type SavePlaidAccountInput = {
  accountId: Scalars['String'];
  publicToken: Scalars['String'];
};

export type SecurityQuestion = {
  __typename?: 'SecurityQuestion';
  answers: Array<SecurityQuestionAnswer>;
  id: Scalars['ID'];
  question: Scalars['String'];
};

export type SecurityQuestionAnswer = {
  __typename?: 'SecurityQuestionAnswer';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type SignatureParamsInput = {
  cadence: Scalars['Int'];
  paymentAmountMax: Scalars['String'];
  paymentReference: Scalars['String'];
  paymentToken: Scalars['String'];
  startTime: Scalars['Float'];
  subscriptionType: Scalars['Int'];
  totalPayments: Scalars['Float'];
};

export type SubmitSecurityQuestionsInput = {
  answerId: Scalars['String'];
  questionId: Scalars['String'];
};

export type SubscriptionError = {
  __typename?: 'SubscriptionError';
  nextRetry?: Maybe<Scalars['DateTime']>;
  retryCount: Scalars['Float'];
  type: SubscriptionErrorType;
};

export enum SubscriptionErrorType {
  Allowance = 'ALLOWANCE',
  Balance = 'BALANCE',
  Transaction = 'TRANSACTION'
}

export enum SubscriptionFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type SubscriptionSignatureParams = {
  __typename?: 'SubscriptionSignatureParams';
  cadence: Scalars['Int'];
  paymentAmountMax: Scalars['String'];
  paymentReference: Scalars['String'];
  paymentToken: Scalars['String'];
  startTime: Scalars['Float'];
  subscriptionType: Scalars['Int'];
  totalPayments: Scalars['Float'];
};

export enum SubscriptionType {
  Autopay = 'AUTOPAY',
  Reminder = 'REMINDER'
}

export type TokenBalance = {
  __typename?: 'TokenBalance';
  /** Token contract address */
  address: Scalars['String'];
  balance: Scalars['Float'];
  balanceRaw: Scalars['String'];
  balanceUSD: Scalars['Float'];
  /** ERC20 decimals */
  decimals: Scalars['Float'];
  network: Scalars['String'];
  price: Scalars['Float'];
  symbol: Scalars['String'];
  tokenImageUrl: Scalars['String'];
  /** Controlling wallet address */
  walletAddress: Scalars['String'];
};

export type Transaction = {
  __typename?: 'Transaction';
  /** @deprecated Unused */
  address: Scalars['String'];
  asset?: Maybe<Scalars['String']>;
  blockNum: Scalars['String'];
  category: Scalars['String'];
  from?: Maybe<Scalars['String']>;
  hash: Scalars['String'];
  id: Scalars['ID'];
  log?: Maybe<TransactionLog>;
  /** Network that the transaction takes place on */
  network: Scalars['String'];
  rawContract?: Maybe<RawContract>;
  to?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type TransactionLog = {
  __typename?: 'TransactionLog';
  address?: Maybe<Scalars['String']>;
  blockHash?: Maybe<Scalars['String']>;
  blockNumber?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  logIndex?: Maybe<Scalars['String']>;
  removed?: Maybe<Scalars['Boolean']>;
  topics?: Maybe<Array<Scalars['String']>>;
  transactionHash?: Maybe<Scalars['String']>;
  transactionIndex?: Maybe<Scalars['String']>;
};

/** Fields to update on userClient */
export type UpdateCurrentUserInput = {
  dob?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  appDomain?: Maybe<AppDomain>;
  associatedWallets: Array<Scalars['String']>;
  attributionSource?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dob?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  /** @deprecated Not in use */
  emailVerified: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  growsurfId?: Maybe<Scalars['String']>;
  growsurfParticipant?: Maybe<GrowsurfParticipant>;
  id: Scalars['ID'];
  kycStatus: KycStatus;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  methodFiEntity?: Maybe<MethodFiEntity>;
  onboardingStatus: OnboardingStatus;
  phone?: Maybe<Scalars['String']>;
  /** @deprecated Not in use */
  phoneVerified?: Maybe<Scalars['Boolean']>;
  picture?: Maybe<Scalars['String']>;
  rewardsBalance: Scalars['Float'];
  rewardsTransactions: Array<RewardTransaction>;
  shouldOnboard: Scalars['Boolean'];
  sub: Scalars['String'];
  timezone: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UserNotification = {
  __typename?: 'UserNotification';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ObjectId'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> = LegacyStitchingResolver<TResult, TParent, TContext, TArgs> | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ACHInstitution: ResolverTypeWrapper<AchInstitution>;
  String: ResolverTypeWrapper<Scalars['String']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Account: ResolverTypeWrapper<Account>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  AccountBalance: ResolverTypeWrapper<AccountBalance>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  AccountProvider: AccountProvider;
  AccountType: AccountType;
  AddTransactionToPaymentInput: AddTransactionToPaymentInput;
  AdminIssuePaymentInput: AdminIssuePaymentInput;
  AppDomain: AppDomain;
  Bill: ResolverTypeWrapper<Bill>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  BillInstitution: ResolverTypeWrapper<BillInstitution>;
  BillSyncStatus: BillSyncStatus;
  BillType: BillType;
  CheckbookAccount: ResolverTypeWrapper<CheckbookAccount>;
  CheckbookAddress: ResolverTypeWrapper<CheckbookAddress>;
  CheckbookNotifyFundingInput: CheckbookNotifyFundingInput;
  CheckbookPayment: ResolverTypeWrapper<CheckbookPayment>;
  CheckbookPaymentStatus: CheckbookPaymentStatus;
  CheckbookSendQueuedPaymentsInput: CheckbookSendQueuedPaymentsInput;
  CheckbookUser: ResolverTypeWrapper<CheckbookUser>;
  CheckbookVirtualCard: ResolverTypeWrapper<CheckbookVirtualCard>;
  CircleBalances: ResolverTypeWrapper<CircleBalances>;
  CognitoKycFlow: ResolverTypeWrapper<CognitoKycFlow>;
  CognitoKycFlowTemplate: ResolverTypeWrapper<CognitoKycFlowTemplate>;
  CreateAccountInput: CreateAccountInput;
  CreateDirectPaymentInput: CreateDirectPaymentInput;
  CreatePaymentInstructionInput: CreatePaymentInstructionInput;
  CreateSubscriptionInput: CreateSubscriptionInput;
  CreateUserInput: CreateUserInput;
  CreateVerifiedAccountInput: CreateVerifiedAccountInput;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  DeliveryDateType: DeliveryDateType;
  DirectPayment: ResolverTypeWrapper<DirectPayment>;
  DirectPaymentStatus: DirectPaymentStatus;
  DirectPaymentTransactionReference: ResolverTypeWrapper<DirectPaymentTransactionReference>;
  DirectPaymentTransactionReferenceStatus: DirectPaymentTransactionReferenceStatus;
  ExternalPayment: ResolverTypeWrapper<ExternalPayment>;
  GasPrice: ResolverTypeWrapper<GasPrice>;
  GasSpeed: ResolverTypeWrapper<GasSpeed>;
  GrowsurfParticipant: ResolverTypeWrapper<GrowsurfParticipant>;
  GrowsurfReferralStats: ResolverTypeWrapper<GrowsurfReferralStats>;
  KycStatus: ResolverTypeWrapper<KycStatus>;
  MercuryAccountInfo: ResolverTypeWrapper<MercuryAccountInfo>;
  MercuryTransaction: ResolverTypeWrapper<MercuryTransaction>;
  MethodFiACHPull: ResolverTypeWrapper<MethodFiAchPull>;
  MethodFiAccount: ResolverTypeWrapper<MethodFiAccount>;
  MethodFiAch: ResolverTypeWrapper<MethodFiAch>;
  MethodFiAddress: ResolverTypeWrapper<MethodFiAddress>;
  MethodFiEntity: ResolverTypeWrapper<MethodFiEntity>;
  MethodFiEntityCorporation: ResolverTypeWrapper<MethodFiEntityCorporation>;
  MethodFiEntityIndividual: ResolverTypeWrapper<MethodFiEntityIndividual>;
  MethodFiError: ResolverTypeWrapper<MethodFiError>;
  MethodFiLiability: ResolverTypeWrapper<MethodFiLiability>;
  MethodFiMerchant: ResolverTypeWrapper<MethodFiMerchant>;
  MethodFiReversal: ResolverTypeWrapper<MethodFiReversal>;
  MethodFiWebhook: ResolverTypeWrapper<MethodFiWebhook>;
  Mutation: ResolverTypeWrapper<{}>;
  Network: Network;
  ObjectId: ResolverTypeWrapper<Scalars['ObjectId']>;
  OnboardingStatus: OnboardingStatus;
  Pagination: Pagination;
  PayableAccount: ResolverTypeWrapper<PayableAccount>;
  PayableAccountType: PayableAccountType;
  Payment: ResolverTypeWrapper<Omit<Payment, 'paymentDestination'> & { paymentDestination?: Maybe<ResolversTypes['PaymentDestination']> }>;
  PaymentAmountType: PaymentAmountType;
  PaymentDestination: ResolversTypes['CheckbookAccount'] | ResolversTypes['CheckbookVirtualCard'] | ResolversTypes['MethodFiAccount'];
  PaymentEventToken: ResolverTypeWrapper<PaymentEventToken>;
  PaymentFrequency: PaymentFrequency;
  PaymentInstruction: ResolverTypeWrapper<PaymentInstruction>;
  PaymentInstructionStatus: PaymentInstructionStatus;
  PaymentLimits: ResolverTypeWrapper<PaymentLimits>;
  PaymentLimitsInput: PaymentLimitsInput;
  PaymentProvider: PaymentProvider;
  PaymentRefund: ResolverTypeWrapper<PaymentRefund>;
  PaymentStatus: PaymentStatus;
  PaymentSubscription: ResolverTypeWrapper<PaymentSubscription>;
  PaymentType: PaymentType;
  PaymentsFilter: PaymentsFilter;
  PlaidAccount: ResolverTypeWrapper<PlaidAccount>;
  PlaidAccountBalance: ResolverTypeWrapper<PlaidAccountBalance>;
  PlaidAccountLiability: ResolverTypeWrapper<PlaidAccountLiability>;
  PlaidInstitution: ResolverTypeWrapper<PlaidInstitution>;
  PopularBill: ResolverTypeWrapper<PopularBill>;
  ProtocolBalance: ResolverTypeWrapper<ProtocolBalance>;
  Query: ResolverTypeWrapper<{}>;
  RawContract: ResolverTypeWrapper<RawContract>;
  RefundPaymentInput: RefundPaymentInput;
  RewardCreditSource: RewardCreditSource;
  RewardTransaction: ResolverTypeWrapper<RewardTransaction>;
  RewardTransactionType: RewardTransactionType;
  SavePlaidAccountInput: SavePlaidAccountInput;
  SecurityQuestion: ResolverTypeWrapper<SecurityQuestion>;
  SecurityQuestionAnswer: ResolverTypeWrapper<SecurityQuestionAnswer>;
  SignatureParamsInput: SignatureParamsInput;
  SubmitSecurityQuestionsInput: SubmitSecurityQuestionsInput;
  SubscriptionError: ResolverTypeWrapper<SubscriptionError>;
  SubscriptionErrorType: SubscriptionErrorType;
  SubscriptionFrequency: SubscriptionFrequency;
  SubscriptionSignatureParams: ResolverTypeWrapper<SubscriptionSignatureParams>;
  SubscriptionType: SubscriptionType;
  TokenBalance: ResolverTypeWrapper<TokenBalance>;
  Transaction: ResolverTypeWrapper<Transaction>;
  TransactionLog: ResolverTypeWrapper<TransactionLog>;
  UpdateCurrentUserInput: UpdateCurrentUserInput;
  User: ResolverTypeWrapper<User>;
  UserNotification: ResolverTypeWrapper<UserNotification>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ACHInstitution: AchInstitution;
  String: Scalars['String'];
  Boolean: Scalars['Boolean'];
  Account: Account;
  ID: Scalars['ID'];
  AccountBalance: AccountBalance;
  Float: Scalars['Float'];
  AddTransactionToPaymentInput: AddTransactionToPaymentInput;
  AdminIssuePaymentInput: AdminIssuePaymentInput;
  Bill: Bill;
  Int: Scalars['Int'];
  BillInstitution: BillInstitution;
  CheckbookAccount: CheckbookAccount;
  CheckbookAddress: CheckbookAddress;
  CheckbookNotifyFundingInput: CheckbookNotifyFundingInput;
  CheckbookPayment: CheckbookPayment;
  CheckbookSendQueuedPaymentsInput: CheckbookSendQueuedPaymentsInput;
  CheckbookUser: CheckbookUser;
  CheckbookVirtualCard: CheckbookVirtualCard;
  CircleBalances: CircleBalances;
  CognitoKycFlow: CognitoKycFlow;
  CognitoKycFlowTemplate: CognitoKycFlowTemplate;
  CreateAccountInput: CreateAccountInput;
  CreateDirectPaymentInput: CreateDirectPaymentInput;
  CreatePaymentInstructionInput: CreatePaymentInstructionInput;
  CreateSubscriptionInput: CreateSubscriptionInput;
  CreateUserInput: CreateUserInput;
  CreateVerifiedAccountInput: CreateVerifiedAccountInput;
  DateTime: Scalars['DateTime'];
  DirectPayment: DirectPayment;
  DirectPaymentTransactionReference: DirectPaymentTransactionReference;
  ExternalPayment: ExternalPayment;
  GasPrice: GasPrice;
  GasSpeed: GasSpeed;
  GrowsurfParticipant: GrowsurfParticipant;
  GrowsurfReferralStats: GrowsurfReferralStats;
  KycStatus: KycStatus;
  MercuryAccountInfo: MercuryAccountInfo;
  MercuryTransaction: MercuryTransaction;
  MethodFiACHPull: MethodFiAchPull;
  MethodFiAccount: MethodFiAccount;
  MethodFiAch: MethodFiAch;
  MethodFiAddress: MethodFiAddress;
  MethodFiEntity: MethodFiEntity;
  MethodFiEntityCorporation: MethodFiEntityCorporation;
  MethodFiEntityIndividual: MethodFiEntityIndividual;
  MethodFiError: MethodFiError;
  MethodFiLiability: MethodFiLiability;
  MethodFiMerchant: MethodFiMerchant;
  MethodFiReversal: MethodFiReversal;
  MethodFiWebhook: MethodFiWebhook;
  Mutation: {};
  ObjectId: Scalars['ObjectId'];
  Pagination: Pagination;
  PayableAccount: PayableAccount;
  Payment: Omit<Payment, 'paymentDestination'> & { paymentDestination?: Maybe<ResolversParentTypes['PaymentDestination']> };
  PaymentDestination: ResolversParentTypes['CheckbookAccount'] | ResolversParentTypes['CheckbookVirtualCard'] | ResolversParentTypes['MethodFiAccount'];
  PaymentEventToken: PaymentEventToken;
  PaymentInstruction: PaymentInstruction;
  PaymentLimits: PaymentLimits;
  PaymentLimitsInput: PaymentLimitsInput;
  PaymentRefund: PaymentRefund;
  PaymentSubscription: PaymentSubscription;
  PaymentsFilter: PaymentsFilter;
  PlaidAccount: PlaidAccount;
  PlaidAccountBalance: PlaidAccountBalance;
  PlaidAccountLiability: PlaidAccountLiability;
  PlaidInstitution: PlaidInstitution;
  PopularBill: PopularBill;
  ProtocolBalance: ProtocolBalance;
  Query: {};
  RawContract: RawContract;
  RefundPaymentInput: RefundPaymentInput;
  RewardTransaction: RewardTransaction;
  SavePlaidAccountInput: SavePlaidAccountInput;
  SecurityQuestion: SecurityQuestion;
  SecurityQuestionAnswer: SecurityQuestionAnswer;
  SignatureParamsInput: SignatureParamsInput;
  SubmitSecurityQuestionsInput: SubmitSecurityQuestionsInput;
  SubscriptionError: SubscriptionError;
  SubscriptionSignatureParams: SubscriptionSignatureParams;
  TokenBalance: TokenBalance;
  Transaction: Transaction;
  TransactionLog: TransactionLog;
  UpdateCurrentUserInput: UpdateCurrentUserInput;
  User: User;
  UserNotification: UserNotification;
};

export type AchInstitutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ACHInstitution'] = ResolversParentTypes['ACHInstitution']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isRTPEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  balances?: Resolver<Maybe<ResolversTypes['AccountBalance']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  owners?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountBalance'] = ResolversParentTypes['AccountBalance']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  protocols?: Resolver<Array<ResolversTypes['ProtocolBalance']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bill'] = ResolversParentTypes['Bill']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amountDue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  canReceive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  connected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  destinationAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['BillInstitution']>, ParentType, ContextType>;
  lastPaymentAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastPaymentDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastStatementBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastSync?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  manual?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mask?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nextPaymentDueDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  nextPaymentMinimumAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  openedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  originalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['AccountProvider'], ParentType, ContextType>;
  remainingStatementBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syncStatus?: Resolver<ResolversTypes['BillSyncStatus'], ParentType, ContextType>;
  testPaymentAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BillType'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillInstitutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillInstitution'] = ResolversParentTypes['BillInstitution']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institutionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckbookAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckbookAccount'] = ResolversParentTypes['CheckbookAccount']> = {
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  holder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['ACHInstitution']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  isRTPEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownedByUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  routingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AccountType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckbookAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckbookAddress'] = ResolversParentTypes['CheckbookAddress']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  line_1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  zip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckbookPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckbookPayment'] = ResolversParentTypes['CheckbookPayment']> = {
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  completionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image_uri?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  recipient?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckbookPaymentStatus'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckbookUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckbookUser'] = ResolversParentTypes['CheckbookUser']> = {
  address?: Resolver<ResolversTypes['CheckbookAddress'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckbookVirtualCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckbookVirtualCard'] = ResolversParentTypes['CheckbookVirtualCard']> = {
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  holderDetails?: Resolver<ResolversTypes['CheckbookUser'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mask?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  renderSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CircleBalancesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CircleBalances'] = ResolversParentTypes['CircleBalances']> = {
  available?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  unsettled?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CognitoKycFlowResolvers<ContextType = any, ParentType extends ResolversParentTypes['CognitoKycFlow'] = ResolversParentTypes['CognitoKycFlow']> = {
  completed_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  shareable_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  template?: Resolver<ResolversTypes['CognitoKycFlowTemplate'], ParentType, ContextType>;
  userCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CognitoKycFlowTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CognitoKycFlowTemplate'] = ResolversParentTypes['CognitoKycFlowTemplate']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DirectPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectPayment'] = ResolversParentTypes['DirectPayment']> = {
  account?: Resolver<ResolversTypes['PayableAccount'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountDue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bill?: Resolver<Maybe<ResolversTypes['Bill']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currentTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  feeAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['AccountProvider'], ParentType, ContextType>;
  rewardsAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DirectPaymentStatus'], ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  testPayment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  toAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  transactionReferences?: Resolver<Array<ResolversTypes['DirectPaymentTransactionReference']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectPaymentTransactionReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectPaymentTransactionReference'] = ResolversParentTypes['DirectPaymentTransactionReference']> = {
  asset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentToken?: Resolver<Maybe<ResolversTypes['PaymentEventToken']>, ParentType, ContextType>;
  sourceToken?: Resolver<Maybe<ResolversTypes['PaymentEventToken']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DirectPaymentTransactionReferenceStatus'], ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalPayment'] = ResolversParentTypes['ExternalPayment']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  completionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  errorReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  estimatedCompletionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PaymentStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GasPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['GasPrice'] = ResolversParentTypes['GasPrice']> = {
  lastBlock?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['Network'], ParentType, ContextType>;
  speeds?: Resolver<ResolversTypes['GasSpeed'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GasSpeedResolvers<ContextType = any, ParentType extends ResolversParentTypes['GasSpeed'] = ResolversParentTypes['GasSpeed']> = {
  fast?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  standard?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GrowsurfParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['GrowsurfParticipant'] = ResolversParentTypes['GrowsurfParticipant']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fraudRiskLevel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  impressionCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  monthlyReferralCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  prevMonthlyReferralCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  referralCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  referralSource?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referralStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referredBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referrer?: Resolver<Maybe<ResolversTypes['GrowsurfParticipant']>, ParentType, ContextType>;
  shareCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  shareUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uniqueImpressionCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  vanityKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GrowsurfReferralStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GrowsurfReferralStats'] = ResolversParentTypes['GrowsurfReferralStats']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  qualifiedReferrals?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rewardsEarned?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  signups?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycStatus'] = ResolversParentTypes['KycStatus']> = {
  cognitoKycFlow?: Resolver<Maybe<ResolversTypes['CognitoKycFlow']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  signature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MercuryAccountInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MercuryAccountInfo'] = ResolversParentTypes['MercuryAccountInfo']> = {
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  availableBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  canReceiveTransactions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currentBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MercuryTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MercuryTransaction'] = ResolversParentTypes['MercuryTransaction']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bankDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  counterpartyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  counterpartyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  counterpartyNickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  estimatedDeliveryDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  externalMemo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  kind?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiAchPullResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiACHPull'] = ResolversParentTypes['MethodFiACHPull']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  effective_date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiAccount'] = ResolversParentTypes['MethodFiAccount']> = {
  ach?: Resolver<ResolversTypes['MethodFiAch'], ParentType, ContextType>;
  available_capabilities?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  capabilities?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  connected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  holder_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['MethodFiMerchant']>, ParentType, ContextType>;
  integrationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  integrationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liability?: Resolver<Maybe<ResolversTypes['MethodFiLiability']>, ParentType, ContextType>;
  manual?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payment_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiAchResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiAch'] = ResolversParentTypes['MethodFiAch']> = {
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  routing?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiAddress'] = ResolversParentTypes['MethodFiAddress']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  line2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiEntity'] = ResolversParentTypes['MethodFiEntity']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['MethodFiAddress']>, ParentType, ContextType>;
  authenticated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  available_capabilities?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  canReceive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canRetrieveData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  capabilities?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  connectionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  corporation?: Resolver<Maybe<ResolversTypes['MethodFiEntityCorporation']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  individual?: Resolver<Maybe<ResolversTypes['MethodFiEntityIndividual']>, ParentType, ContextType>;
  locked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiEntityCorporationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiEntityCorporation'] = ResolversParentTypes['MethodFiEntityCorporation']> = {
  dba?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ein?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owners?: Resolver<Array<ResolversTypes['MethodFiEntityIndividual']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiEntityIndividualResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiEntityIndividual'] = ResolversParentTypes['MethodFiEntityIndividual']> = {
  address?: Resolver<Maybe<ResolversTypes['MethodFiAddress']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiError'] = ResolversParentTypes['MethodFiError']> = {
  code?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sub_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiLiabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiLiability'] = ResolversParentTypes['MethodFiLiability']> = {
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastPaymentAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastPaymentDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastStatementBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastSync?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  mask?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mch_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nextPaymentDueDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  nextPaymentMinimumAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  openedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  remainingStatementBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  syncStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiMerchantResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiMerchant'] = ResolversParentTypes['MethodFiMerchant']> = {
  accountCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountPrefixes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  averagePaymentTiming?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentsSent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  types?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiReversalResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiReversal'] = ResolversParentTypes['MethodFiReversal']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['MethodFiError']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  methodFiPaymentId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  pmt_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  target_account?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trace_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MethodFiWebhookResolvers<ContextType = any, ParentType extends ResolversParentTypes['MethodFiWebhook'] = ResolversParentTypes['MethodFiWebhook']> = {
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  addAccount?: Resolver<ResolversTypes['MethodFiAccount'], ParentType, ContextType, RequireFields<MutationAddAccountArgs, 'accountId' | 'merchantId'>>;
  addAffiliateReferralCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddAffiliateReferralCodeArgs, 'referralCode'>>;
  addAssociatedWallet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddAssociatedWalletArgs, 'address'>>;
  addTransactionToDirectPayment?: Resolver<ResolversTypes['DirectPayment'], ParentType, ContextType, RequireFields<MutationAddTransactionToDirectPaymentArgs, 'addTransactionToPaymentInput'>>;
  adminCreateDirectPayment?: Resolver<ResolversTypes['DirectPayment'], ParentType, ContextType, RequireFields<MutationAdminCreateDirectPaymentArgs, 'createDirectPaymentInput' | 'userId'>>;
  adminIssuePayment?: Resolver<Maybe<ResolversTypes['Payment']>, ParentType, ContextType, RequireFields<MutationAdminIssuePaymentArgs, 'issuePaymentInput'>>;
  approvePaymentReversal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationApprovePaymentReversalArgs, 'paymentId'>>;
  cancelPaymentInstruction?: Resolver<ResolversTypes['PaymentInstruction'], ParentType, ContextType, RequireFields<MutationCancelPaymentInstructionArgs, 'paymentInstructionId'>>;
  checkbookNotifyFunding?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCheckbookNotifyFundingArgs, 'notifyFundingInput'>>;
  checkbookSendQueuedPayments?: Resolver<Maybe<Array<ResolversTypes['CheckbookPayment']>>, ParentType, ContextType, RequireFields<MutationCheckbookSendQueuedPaymentsArgs, never>>;
  connectBills?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationConnectBillsArgs, 'accountIds'>>;
  createCheckbookAccount?: Resolver<ResolversTypes['CheckbookAccount'], ParentType, ContextType, RequireFields<MutationCreateCheckbookAccountArgs, 'createAccountInput'>>;
  createDirectPayment?: Resolver<ResolversTypes['DirectPayment'], ParentType, ContextType, RequireFields<MutationCreateDirectPaymentArgs, 'createDirectPaymentInput'>>;
  createGrowsurfParticipant?: Resolver<Maybe<ResolversTypes['GrowsurfParticipant']>, ParentType, ContextType, RequireFields<MutationCreateGrowsurfParticipantArgs, never>>;
  createPaymentInstruction?: Resolver<ResolversTypes['PaymentInstruction'], ParentType, ContextType, RequireFields<MutationCreatePaymentInstructionArgs, 'createPaymentInstructionInput'>>;
  createSpritzSourceAccount?: Resolver<ResolversTypes['MethodFiAccount'], ParentType, ContextType>;
  createSubscription?: Resolver<ResolversTypes['PaymentSubscription'], ParentType, ContextType, RequireFields<MutationCreateSubscriptionArgs, 'createSubscriptionInput'>>;
  createUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'createUser'>>;
  createUserAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateUserAccountArgs, 'address' | 'userId'>>;
  createVerifiedAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateVerifiedAccountArgs, 'createVerifiedAccountInput'>>;
  createVirtualCard?: Resolver<ResolversTypes['CheckbookVirtualCard'], ParentType, ContextType>;
  deleteBill?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteBillArgs, 'accountId'>>;
  deleteCheckbookAccount?: Resolver<ResolversTypes['CheckbookAccount'], ParentType, ContextType, RequireFields<MutationDeleteCheckbookAccountArgs, 'accountId'>>;
  deleteDirectPayment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteDirectPaymentArgs, 'directPaymentId'>>;
  deleteSubscription?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteSubscriptionArgs, 'subscriptionId'>>;
  disconnectBill?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDisconnectBillArgs, 'accountId'>>;
  flushBalances?: Resolver<Array<ResolversTypes['TokenBalance']>, ParentType, ContextType, RequireFields<MutationFlushBalancesArgs, 'addresses'>>;
  forcePayment?: Resolver<ResolversTypes['Payment'], ParentType, ContextType, RequireFields<MutationForcePaymentArgs, 'paymentId'>>;
  grantCredit?: Resolver<ResolversTypes['RewardTransaction'], ParentType, ContextType, RequireFields<MutationGrantCreditArgs, 'amount' | 'userId'>>;
  kycStatusSetUserCompleted?: Resolver<ResolversTypes['KycStatus'], ParentType, ContextType>;
  linkAccountToUser?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationLinkAccountToUserArgs, 'address' | 'userId'>>;
  lockEntityAuth?: Resolver<ResolversTypes['MethodFiEntity'], ParentType, ContextType>;
  markNotificationAsRead?: Resolver<Maybe<ResolversTypes['UserNotification']>, ParentType, ContextType, RequireFields<MutationMarkNotificationAsReadArgs, 'notificationId'>>;
  methodFiUpdateSSN?: Resolver<ResolversTypes['MethodFiEntity'], ParentType, ContextType, RequireFields<MutationMethodFiUpdateSsnArgs, 'ssn'>>;
  refreshEntities?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  refundPayment?: Resolver<ResolversTypes['Payment'], ParentType, ContextType, RequireFields<MutationRefundPaymentArgs, 'refundPaymentInput'>>;
  removePlaidAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemovePlaidAccountArgs, 'accountId'>>;
  renameBill?: Resolver<ResolversTypes['Bill'], ParentType, ContextType, RequireFields<MutationRenameBillArgs, 'accountId' | 'name'>>;
  renameCheckbookAccount?: Resolver<ResolversTypes['CheckbookAccount'], ParentType, ContextType, RequireFields<MutationRenameCheckbookAccountArgs, 'accountId' | 'name'>>;
  resetEntity?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationResetEntityArgs, 'userId'>>;
  resyncAccounts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  resyncEntityAccounts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationResyncEntityAccountsArgs, 'entityId'>>;
  retrySubscriptionCharge?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRetrySubscriptionChargeArgs, 'subscriptionId'>>;
  savePlaidAccount?: Resolver<ResolversTypes['PlaidAccount'], ParentType, ContextType, RequireFields<MutationSavePlaidAccountArgs, 'savePlaidAccountInput'>>;
  simulatePaymentUpdate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSimulatePaymentUpdateArgs, 'paymentId' | 'status'>>;
  submitSecurityQuestions?: Resolver<Array<ResolversTypes['SecurityQuestion']>, ParentType, ContextType, RequireFields<MutationSubmitSecurityQuestionsArgs, 'submission'>>;
  updateAppDomain?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateAppDomainArgs, 'appDomain'>>;
  updateAttributionSource?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateAttributionSourceArgs, 'attributionSource'>>;
  updateBillType?: Resolver<ResolversTypes['Bill'], ParentType, ContextType, RequireFields<MutationUpdateBillTypeArgs, 'accountId' | 'type'>>;
  updateCurrentUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateCurrentUserArgs, 'userUpdate'>>;
  updateEntityAuthentication?: Resolver<Maybe<ResolversTypes['MethodFiEntity']>, ParentType, ContextType, RequireFields<MutationUpdateEntityAuthenticationArgs, never>>;
  updateOnboardingStatus?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateOnboardingStatusArgs, 'status'>>;
  updateUserTimezone?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUserTimezoneArgs, 'timezone'>>;
  verifyPlaidAccounts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export interface ObjectIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ObjectId'], any> {
  name: 'ObjectId';
}

export type PayableAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayableAccount'] = ResolversParentTypes['PayableAccount']> = {
  accountProvider?: Resolver<ResolversTypes['AccountProvider'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownedByUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['BillType']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PayableAccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payment'] = ResolversParentTypes['Payment']> = {
  account?: Resolver<Maybe<ResolversTypes['PayableAccount']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bill?: Resolver<Maybe<ResolversTypes['Bill']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  directPayment?: Resolver<Maybe<ResolversTypes['DirectPayment']>, ParentType, ContextType>;
  directPaymentId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  externalPayment?: Resolver<Maybe<ResolversTypes['ExternalPayment']>, ParentType, ContextType>;
  externalPaymentId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  feeAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  paymentDestination?: Resolver<Maybe<ResolversTypes['PaymentDestination']>, ParentType, ContextType>;
  paymentInstruction?: Resolver<Maybe<ResolversTypes['PaymentInstruction']>, ParentType, ContextType>;
  paymentInstructionId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  paymentProvider?: Resolver<ResolversTypes['PaymentProvider'], ParentType, ContextType>;
  refund?: Resolver<Maybe<ResolversTypes['PaymentRefund']>, ParentType, ContextType>;
  rewardsAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rewardsTransaction?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PaymentStatus'], ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentDestinationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentDestination'] = ResolversParentTypes['PaymentDestination']> = {
  __resolveType: TypeResolveFn<'CheckbookAccount' | 'CheckbookVirtualCard' | 'MethodFiAccount', ParentType, ContextType>;
};

export type PaymentEventTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentEventToken'] = ResolversParentTypes['PaymentEventToken']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountRaw?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decimals?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentInstructionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentInstruction'] = ResolversParentTypes['PaymentInstruction']> = {
  accountDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountType?: Resolver<ResolversTypes['PaymentAmountType'], ParentType, ContextType>;
  bill?: Resolver<Maybe<ResolversTypes['Bill']>, ParentType, ContextType>;
  deliveryDateType?: Resolver<ResolversTypes['DeliveryDateType'], ParentType, ContextType>;
  deliveryDaysBefore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deliveryExactDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentFrequency?: Resolver<ResolversTypes['PaymentFrequency'], ParentType, ContextType>;
  plaidAccount?: Resolver<Maybe<ResolversTypes['PlaidAccount']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['AccountProvider'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PaymentInstructionStatus'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentLimitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentLimits'] = ResolversParentTypes['PaymentLimits']> = {
  absolute?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  delay?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentRefundResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentRefund'] = ResolversParentTypes['PaymentRefund']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentSubscription'] = ResolversParentTypes['PaymentSubscription']> = {
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  blockchainSubscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['SubscriptionError']>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['SubscriptionFrequency'], ParentType, ContextType>;
  frequencyValue?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nextSubscriptionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['AccountProvider'], ParentType, ContextType>;
  signatureParams?: Resolver<Maybe<ResolversTypes['SubscriptionSignatureParams']>, ParentType, ContextType>;
  signedMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  subscriptionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tokenSymbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalPayments?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SubscriptionType'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  walletAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlaidAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaidAccount'] = ResolversParentTypes['PlaidAccount']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['PlaidAccountBalance']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['PlaidInstitution']>, ParentType, ContextType>;
  institutionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  liability?: Resolver<Maybe<ResolversTypes['PlaidAccountLiability']>, ParentType, ContextType>;
  mask?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  methodFiAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officialName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlaidAccountBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaidAccountBalance'] = ResolversParentTypes['PlaidAccountBalance']> = {
  available?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  current?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlaidAccountLiabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaidAccountLiability'] = ResolversParentTypes['PlaidAccountLiability']> = {
  lastPaymentAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastPaymentDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastStatementBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minPaymentAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nextPaymentAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nextPaymentDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overdue?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlaidInstitutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaidInstitution'] = ResolversParentTypes['PlaidInstitution']> = {
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institution_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopularBillResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopularBill'] = ResolversParentTypes['PopularBill']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institution?: Resolver<ResolversTypes['BillInstitution'], ParentType, ContextType>;
  merchantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BillType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolBalance'] = ResolversParentTypes['ProtocolBalance']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  achInstitution?: Resolver<Maybe<ResolversTypes['ACHInstitution']>, ParentType, ContextType, RequireFields<QueryAchInstitutionArgs, 'routingNumber'>>;
  activeBills?: Resolver<Array<ResolversTypes['Bill']>, ParentType, ContextType>;
  adminDirectPayment?: Resolver<Maybe<ResolversTypes['DirectPayment']>, ParentType, ContextType, RequireFields<QueryAdminDirectPaymentArgs, 'directPaymentId'>>;
  adminDirectPayments?: Resolver<Array<ResolversTypes['DirectPayment']>, ParentType, ContextType, RequireFields<QueryAdminDirectPaymentsArgs, never>>;
  adminPayments?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType, RequireFields<QueryAdminPaymentsArgs, never>>;
  adminPaymentsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryAdminPaymentsCountArgs, never>>;
  adminRecentPayments?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType, RequireFields<QueryAdminRecentPaymentsArgs, 'userId'>>;
  adminTransactionPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryAdminTransactionPriceArgs, 'amount' | 'userId'>>;
  bankAccounts?: Resolver<Array<ResolversTypes['CheckbookAccount']>, ParentType, ContextType, RequireFields<QueryBankAccountsArgs, 'ownedByUser'>>;
  bills?: Resolver<Array<ResolversTypes['Bill']>, ParentType, ContextType>;
  checkbookPrefundedAccountBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  circleBalances?: Resolver<ResolversTypes['CircleBalances'], ParentType, ContextType>;
  directPayment?: Resolver<Maybe<ResolversTypes['DirectPayment']>, ParentType, ContextType, RequireFields<QueryDirectPaymentArgs, 'paymentId'>>;
  directPayments?: Resolver<Array<ResolversTypes['DirectPayment']>, ParentType, ContextType>;
  findByWalletAddress?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryFindByWalletAddressArgs, 'address'>>;
  gasPrice?: Resolver<Maybe<ResolversTypes['GasPrice']>, ParentType, ContextType, RequireFields<QueryGasPriceArgs, 'network'>>;
  getAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  getCurrentUser?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  getMethodFiAuthToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  getPayableAccounts?: Resolver<Array<ResolversTypes['PayableAccount']>, ParentType, ContextType, RequireFields<QueryGetPayableAccountsArgs, 'accountIds'>>;
  getPlaidAccounts?: Resolver<Array<ResolversTypes['PlaidAccount']>, ParentType, ContextType>;
  getPlaidAccountsForUser?: Resolver<Array<ResolversTypes['PlaidAccount']>, ParentType, ContextType, RequireFields<QueryGetPlaidAccountsForUserArgs, 'userId'>>;
  getPlaidLinkToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  getSpritzSourceAccount?: Resolver<Maybe<ResolversTypes['MethodFiAccount']>, ParentType, ContextType>;
  getUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<QueryGetUserArgs, 'userId'>>;
  getUserAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType, RequireFields<QueryGetUserAccountArgs, 'userId'>>;
  getUsers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryGetUsersArgs, never>>;
  growsurfParticipant?: Resolver<Maybe<ResolversTypes['GrowsurfParticipant']>, ParentType, ContextType>;
  growsurfSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasBillPayPayments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPayments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  me?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  merchants?: Resolver<Array<ResolversTypes['MethodFiMerchant']>, ParentType, ContextType, RequireFields<QueryMerchantsArgs, never>>;
  mercuryAccountInfo?: Resolver<ResolversTypes['MercuryAccountInfo'], ParentType, ContextType>;
  mercuryAccounts?: Resolver<Array<ResolversTypes['MercuryAccountInfo']>, ParentType, ContextType>;
  mercuryTransactions?: Resolver<Array<ResolversTypes['MercuryTransaction']>, ParentType, ContextType, RequireFields<QueryMercuryTransactionsArgs, never>>;
  methodFiACHReport?: Resolver<Array<ResolversTypes['MethodFiACHPull']>, ParentType, ContextType>;
  methodFiEntity?: Resolver<Maybe<ResolversTypes['MethodFiEntity']>, ParentType, ContextType>;
  methodFiWebhooks?: Resolver<Array<ResolversTypes['MethodFiWebhook']>, ParentType, ContextType>;
  notifications?: Resolver<Array<ResolversTypes['UserNotification']>, ParentType, ContextType>;
  outstandingDirectPayments?: Resolver<Array<ResolversTypes['DirectPayment']>, ParentType, ContextType, RequireFields<QueryOutstandingDirectPaymentsArgs, never>>;
  paymentByExternalId?: Resolver<ResolversTypes['Payment'], ParentType, ContextType, RequireFields<QueryPaymentByExternalIdArgs, 'externalId'>>;
  paymentHistory?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType>;
  paymentInstructions?: Resolver<Array<ResolversTypes['PaymentInstruction']>, ParentType, ContextType>;
  paymentLimits?: Resolver<ResolversTypes['PaymentLimits'], ParentType, ContextType, RequireFields<QueryPaymentLimitsArgs, 'paymentLimitsInput'>>;
  payments?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType, RequireFields<QueryPaymentsArgs, never>>;
  paymentsInProgress?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType>;
  pendingActivationBills?: Resolver<Array<ResolversTypes['Bill']>, ParentType, ContextType>;
  popularBills?: Resolver<Array<ResolversTypes['PopularBill']>, ParentType, ContextType>;
  popularMerchants?: Resolver<Array<ResolversTypes['MethodFiMerchant']>, ParentType, ContextType, RequireFields<QueryPopularMerchantsArgs, never>>;
  recurringPaymentInstructions?: Resolver<Array<ResolversTypes['PaymentInstruction']>, ParentType, ContextType>;
  referralStats?: Resolver<Maybe<ResolversTypes['GrowsurfReferralStats']>, ParentType, ContextType>;
  reversals?: Resolver<ResolversTypes['MethodFiReversal'], ParentType, ContextType>;
  rewardsBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rewardTransactions?: Resolver<Array<ResolversTypes['RewardTransaction']>, ParentType, ContextType>;
  scheduledPayments?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType>;
  sdkConfig?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  securityQuestions?: Resolver<Array<ResolversTypes['SecurityQuestion']>, ParentType, ContextType>;
  subscriptions?: Resolver<Array<ResolversTypes['PaymentSubscription']>, ParentType, ContextType>;
  tokenBalances?: Resolver<Array<ResolversTypes['TokenBalance']>, ParentType, ContextType, RequireFields<QueryTokenBalancesArgs, 'address'>>;
  totalTokenBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryTotalTokenBalanceArgs, 'address'>>;
  transactionPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryTransactionPriceArgs, 'amount'>>;
  transactions?: Resolver<Array<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<QueryTransactionsArgs, 'address'>>;
  transactionVolume?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  upcomingPayments?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType>;
  userBills?: Resolver<Array<ResolversTypes['Bill']>, ParentType, ContextType, RequireFields<QueryUserBillsArgs, 'userId'>>;
  userPayment?: Resolver<ResolversTypes['Payment'], ParentType, ContextType, RequireFields<QueryUserPaymentArgs, 'paymentId'>>;
  userPaymentInstructions?: Resolver<Array<ResolversTypes['PaymentInstruction']>, ParentType, ContextType, RequireFields<QueryUserPaymentInstructionsArgs, 'userId'>>;
  userPayments?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType, RequireFields<QueryUserPaymentsArgs, 'userId'>>;
  userUpcomingPayments?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType, RequireFields<QueryUserUpcomingPaymentsArgs, 'userId'>>;
  validateReferralCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryValidateReferralCodeArgs, 'referralCode'>>;
  virtualCard?: Resolver<Maybe<ResolversTypes['CheckbookVirtualCard']>, ParentType, ContextType>;
  virtualCards?: Resolver<Array<ResolversTypes['CheckbookVirtualCard']>, ParentType, ContextType>;
};

export type RawContractResolvers<ContextType = any, ParentType extends ResolversParentTypes['RawContract'] = ResolversParentTypes['RawContract']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  decimals?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rawValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RewardTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RewardTransaction'] = ResolversParentTypes['RewardTransaction']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  paymentId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['RewardCreditSource']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RewardTransactionType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityQuestion'] = ResolversParentTypes['SecurityQuestion']> = {
  answers?: Resolver<Array<ResolversTypes['SecurityQuestionAnswer']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityQuestionAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityQuestionAnswer'] = ResolversParentTypes['SecurityQuestionAnswer']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionError'] = ResolversParentTypes['SubscriptionError']> = {
  nextRetry?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  retryCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SubscriptionErrorType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionSignatureParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionSignatureParams'] = ResolversParentTypes['SubscriptionSignatureParams']> = {
  cadence?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentAmountMax?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  subscriptionType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPayments?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TokenBalance'] = ResolversParentTypes['TokenBalance']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balanceRaw?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  balanceUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  decimals?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenImageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  walletAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Transaction'] = ResolversParentTypes['Transaction']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockNum?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  log?: Resolver<Maybe<ResolversTypes['TransactionLog']>, ParentType, ContextType>;
  network?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rawContract?: Resolver<Maybe<ResolversTypes['RawContract']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionLog'] = ResolversParentTypes['TransactionLog']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  topics?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  transactionHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  appDomain?: Resolver<Maybe<ResolversTypes['AppDomain']>, ParentType, ContextType>;
  associatedWallets?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  attributionSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailVerified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  growsurfId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  growsurfParticipant?: Resolver<Maybe<ResolversTypes['GrowsurfParticipant']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kycStatus?: Resolver<ResolversTypes['KycStatus'], ParentType, ContextType>;
  lastLogin?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  methodFiEntity?: Resolver<Maybe<ResolversTypes['MethodFiEntity']>, ParentType, ContextType>;
  onboardingStatus?: Resolver<ResolversTypes['OnboardingStatus'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneVerified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  picture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rewardsBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rewardsTransactions?: Resolver<Array<ResolversTypes['RewardTransaction']>, ParentType, ContextType>;
  shouldOnboard?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sub?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserNotification'] = ResolversParentTypes['UserNotification']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ACHInstitution?: AchInstitutionResolvers<ContextType>;
  Account?: AccountResolvers<ContextType>;
  AccountBalance?: AccountBalanceResolvers<ContextType>;
  Bill?: BillResolvers<ContextType>;
  BillInstitution?: BillInstitutionResolvers<ContextType>;
  CheckbookAccount?: CheckbookAccountResolvers<ContextType>;
  CheckbookAddress?: CheckbookAddressResolvers<ContextType>;
  CheckbookPayment?: CheckbookPaymentResolvers<ContextType>;
  CheckbookUser?: CheckbookUserResolvers<ContextType>;
  CheckbookVirtualCard?: CheckbookVirtualCardResolvers<ContextType>;
  CircleBalances?: CircleBalancesResolvers<ContextType>;
  CognitoKycFlow?: CognitoKycFlowResolvers<ContextType>;
  CognitoKycFlowTemplate?: CognitoKycFlowTemplateResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DirectPayment?: DirectPaymentResolvers<ContextType>;
  DirectPaymentTransactionReference?: DirectPaymentTransactionReferenceResolvers<ContextType>;
  ExternalPayment?: ExternalPaymentResolvers<ContextType>;
  GasPrice?: GasPriceResolvers<ContextType>;
  GasSpeed?: GasSpeedResolvers<ContextType>;
  GrowsurfParticipant?: GrowsurfParticipantResolvers<ContextType>;
  GrowsurfReferralStats?: GrowsurfReferralStatsResolvers<ContextType>;
  KycStatus?: KycStatusResolvers<ContextType>;
  MercuryAccountInfo?: MercuryAccountInfoResolvers<ContextType>;
  MercuryTransaction?: MercuryTransactionResolvers<ContextType>;
  MethodFiACHPull?: MethodFiAchPullResolvers<ContextType>;
  MethodFiAccount?: MethodFiAccountResolvers<ContextType>;
  MethodFiAch?: MethodFiAchResolvers<ContextType>;
  MethodFiAddress?: MethodFiAddressResolvers<ContextType>;
  MethodFiEntity?: MethodFiEntityResolvers<ContextType>;
  MethodFiEntityCorporation?: MethodFiEntityCorporationResolvers<ContextType>;
  MethodFiEntityIndividual?: MethodFiEntityIndividualResolvers<ContextType>;
  MethodFiError?: MethodFiErrorResolvers<ContextType>;
  MethodFiLiability?: MethodFiLiabilityResolvers<ContextType>;
  MethodFiMerchant?: MethodFiMerchantResolvers<ContextType>;
  MethodFiReversal?: MethodFiReversalResolvers<ContextType>;
  MethodFiWebhook?: MethodFiWebhookResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  ObjectId?: GraphQLScalarType;
  PayableAccount?: PayableAccountResolvers<ContextType>;
  Payment?: PaymentResolvers<ContextType>;
  PaymentDestination?: PaymentDestinationResolvers<ContextType>;
  PaymentEventToken?: PaymentEventTokenResolvers<ContextType>;
  PaymentInstruction?: PaymentInstructionResolvers<ContextType>;
  PaymentLimits?: PaymentLimitsResolvers<ContextType>;
  PaymentRefund?: PaymentRefundResolvers<ContextType>;
  PaymentSubscription?: PaymentSubscriptionResolvers<ContextType>;
  PlaidAccount?: PlaidAccountResolvers<ContextType>;
  PlaidAccountBalance?: PlaidAccountBalanceResolvers<ContextType>;
  PlaidAccountLiability?: PlaidAccountLiabilityResolvers<ContextType>;
  PlaidInstitution?: PlaidInstitutionResolvers<ContextType>;
  PopularBill?: PopularBillResolvers<ContextType>;
  ProtocolBalance?: ProtocolBalanceResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RawContract?: RawContractResolvers<ContextType>;
  RewardTransaction?: RewardTransactionResolvers<ContextType>;
  SecurityQuestion?: SecurityQuestionResolvers<ContextType>;
  SecurityQuestionAnswer?: SecurityQuestionAnswerResolvers<ContextType>;
  SubscriptionError?: SubscriptionErrorResolvers<ContextType>;
  SubscriptionSignatureParams?: SubscriptionSignatureParamsResolvers<ContextType>;
  TokenBalance?: TokenBalanceResolvers<ContextType>;
  Transaction?: TransactionResolvers<ContextType>;
  TransactionLog?: TransactionLogResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserNotification?: UserNotificationResolvers<ContextType>;
};


/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>;

export type FullTokenBalanceFragment = { __typename?: 'TokenBalance', address: string, walletAddress: string, symbol: string, network: string, decimals: number, balance: number, balanceRaw: string, balanceUSD: number, price: number, tokenImageUrl: string };

export type GetWalletTokenBalancesQueryVariables = Exact<{
  address: Scalars['String'];
  network?: Maybe<Scalars['String']>;
}>;


export type GetWalletTokenBalancesQuery = { __typename?: 'Query', tokenBalances: Array<(
    { __typename?: 'TokenBalance' }
    & FullTokenBalanceFragment
  )> };

export type FlushBalancesMutationVariables = Exact<{
  addresses: Array<Scalars['String']> | Scalars['String'];
}>;


export type FlushBalancesMutation = { __typename?: 'Mutation', flushBalances: Array<(
    { __typename?: 'TokenBalance' }
    & FullTokenBalanceFragment
  )> };

export type GetBalancesQueryVariables = Exact<{
  address: Scalars['String'];
  network?: Maybe<Scalars['String']>;
  paymentLimitsInput: PaymentLimitsInput;
}>;


export type GetBalancesQuery = { __typename?: 'Query', rewardsBalance: number, sdkConfig: Array<string>, tokenBalances: Array<(
    { __typename?: 'TokenBalance' }
    & FullTokenBalanceFragment
  )>, paymentLimits: { __typename?: 'PaymentLimits', absolute: number, delay: number } };

export type FullBankAccountFragment = { __typename?: 'CheckbookAccount', id: string, userId: any, type: AccountType, email: string, holder: string, name: string, accountNumber?: Maybe<string>, routingNumber?: Maybe<string>, ownedByUser: boolean, institution?: Maybe<{ __typename?: 'ACHInstitution', logo?: Maybe<string>, name: string }> };

export type BankAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type BankAccountsQuery = { __typename?: 'Query', bankAccounts: Array<(
    { __typename?: 'CheckbookAccount' }
    & FullBankAccountFragment
  )> };

export type LookupInstitutionQueryVariables = Exact<{
  routingNumber: Scalars['String'];
}>;


export type LookupInstitutionQuery = { __typename?: 'Query', achInstitution?: Maybe<{ __typename?: 'ACHInstitution', logo?: Maybe<string>, name: string, isRTPEnabled: boolean }> };

export type AddBankAccountMutationVariables = Exact<{
  createAccountInput: CreateAccountInput;
}>;


export type AddBankAccountMutation = { __typename?: 'Mutation', createCheckbookAccount: (
    { __typename?: 'CheckbookAccount' }
    & FullBankAccountFragment
  ) };

export type DeleteBankAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type DeleteBankAccountMutation = { __typename?: 'Mutation', deleteCheckbookAccount: (
    { __typename?: 'CheckbookAccount' }
    & FullBankAccountFragment
  ) };

export type RenameBankAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
  name: Scalars['String'];
}>;


export type RenameBankAccountMutation = { __typename?: 'Mutation', renameCheckbookAccount: (
    { __typename?: 'CheckbookAccount' }
    & FullBankAccountFragment
  ) };

export type FullSpritzCardFragment = { __typename?: 'CheckbookVirtualCard', renderSecret: string, externalId: string, id: string, mask: string, balance: number, holderDetails: { __typename?: 'CheckbookUser', firstName: string, lastName: string, phone: string, address: { __typename?: 'CheckbookAddress', zip: string, state: string, city: string, line_1: string } } };

export type SpritzCardQueryVariables = Exact<{ [key: string]: never; }>;


export type SpritzCardQuery = { __typename?: 'Query', virtualCard?: Maybe<(
    { __typename?: 'CheckbookVirtualCard' }
    & FullSpritzCardFragment
  )> };

export type CreateSpritzCardMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSpritzCardMutation = { __typename?: 'Mutation', createVirtualCard: (
    { __typename?: 'CheckbookVirtualCard' }
    & FullSpritzCardFragment
  ) };

export type GasPriceQueryVariables = Exact<{
  network: Scalars['String'];
}>;


export type GasPriceQuery = { __typename?: 'Query', gasPrice?: Maybe<{ __typename?: 'GasPrice', network: Network, lastBlock: number, speeds: { __typename?: 'GasSpeed', instant?: Maybe<number>, fast?: Maybe<number>, standard?: Maybe<number> } }> };

export type FullMethodFiEntityFragment = { __typename?: 'MethodFiEntity', id: string, canReceive: boolean, canRetrieveData: boolean, authenticated: boolean, locked: boolean, active: boolean, error?: Maybe<string>, status: string, address?: Maybe<{ __typename?: 'MethodFiAddress', zip?: Maybe<string> }> };

export type CanAddBillsQueryVariables = Exact<{ [key: string]: never; }>;


export type CanAddBillsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, kycStatus: (
      { __typename?: 'KycStatus' }
      & KycStatusBriefFragment
    ), methodFiEntity?: Maybe<(
      { __typename?: 'MethodFiEntity' }
      & FullMethodFiEntityFragment
    )> } };

export type MethodFiAuthTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type MethodFiAuthTokenQuery = { __typename?: 'Query', getMethodFiAuthToken?: Maybe<string> };

export type BillConnectionDataQueryVariables = Exact<{ [key: string]: never; }>;


export type BillConnectionDataQuery = { __typename?: 'Query', methodFiEntity?: Maybe<(
    { __typename?: 'MethodFiEntity' }
    & FullMethodFiEntityFragment
  )> };

export type MerchantSummaryFragment = { __typename?: 'MethodFiMerchant', id: string, name: string, parentName: string, logo?: Maybe<string>, description?: Maybe<string>, types: Array<string> };

export type AddCustomBillMutationVariables = Exact<{
  merchantId: Scalars['String'];
  accountId: Scalars['String'];
  type?: Maybe<BillType>;
}>;


export type AddCustomBillMutation = { __typename?: 'Mutation', addAccount: { __typename?: 'MethodFiAccount', id: string, nickname?: Maybe<string>, manual?: Maybe<boolean>, capabilities: Array<string> } };

export type MerchantsQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  type?: Maybe<BillType>;
}>;


export type MerchantsQuery = { __typename?: 'Query', merchants: Array<(
    { __typename?: 'MethodFiMerchant' }
    & MerchantSummaryFragment
  )> };

export type PopularMerchantsQueryVariables = Exact<{
  type?: Maybe<BillType>;
}>;


export type PopularMerchantsQuery = { __typename?: 'Query', popularMerchants: Array<(
    { __typename?: 'MethodFiMerchant' }
    & MerchantSummaryFragment
  )> };

export type InstitutionFragment = { __typename?: 'BillInstitution', id: string, institutionId: string, logo?: Maybe<string>, logoUrl?: Maybe<string>, name: string };

export type FullBillFragment = { __typename?: 'Bill', id: string, accountId: string, provider: AccountProvider, connected: boolean, verified: boolean, mask?: Maybe<string>, type: BillType, name: string, originalName: string, manual?: Maybe<boolean>, canReceive: boolean, balance?: Maybe<number>, openedAt?: Maybe<any>, nextPaymentDueDate?: Maybe<any>, amountDue?: Maybe<number>, syncStatus: BillSyncStatus, lastSync?: Maybe<any>, createdAt?: Maybe<any>, testPaymentAvailable: boolean, institution?: Maybe<(
    { __typename?: 'BillInstitution' }
    & InstitutionFragment
  )> };

export type FullPaymentSubscriptionFragment = { __typename?: 'PaymentSubscription', id: string, accountId: any, provider: AccountProvider, type: SubscriptionType, amount?: Maybe<number>, network: string, startDate: any, nextSubscriptionDate?: Maybe<any>, frequency: SubscriptionFrequency, frequencyValue: number, blockchainSubscriptionId?: Maybe<string>, walletAddress?: Maybe<string>, paymentToken?: Maybe<string>, tokenSymbol?: Maybe<string>, subscriptionCount: number, totalPayments: number, processing: boolean, error?: Maybe<{ __typename?: 'SubscriptionError', type: SubscriptionErrorType, retryCount: number, nextRetry?: Maybe<any> }> };

export type FullPopularBillFragment = { __typename?: 'PopularBill', id: string, name: string, count: number, type: BillType, institution: (
    { __typename?: 'BillInstitution' }
    & InstitutionFragment
  ) };

export type PopularBillsQueryVariables = Exact<{ [key: string]: never; }>;


export type PopularBillsQuery = { __typename?: 'Query', popularBills: Array<(
    { __typename?: 'PopularBill' }
    & FullPopularBillFragment
  )> };

export type BillsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type BillsDataQuery = { __typename?: 'Query', bills: Array<(
    { __typename?: 'Bill' }
    & FullBillFragment
  )>, subscriptions: Array<(
    { __typename?: 'PaymentSubscription' }
    & FullPaymentSubscriptionFragment
  )>, bankAccounts: Array<(
    { __typename?: 'CheckbookAccount' }
    & FullBankAccountFragment
  )> };

export type ConnectBillsMutationVariables = Exact<{
  accountIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ConnectBillsMutation = { __typename?: 'Mutation', connectBills: boolean };

export type DeleteBillMutationVariables = Exact<{
  accountId: Scalars['String'];
  provider?: Maybe<AccountProvider>;
}>;


export type DeleteBillMutation = { __typename?: 'Mutation', deleteBill: boolean };

export type RenameBillMutationVariables = Exact<{
  accountId: Scalars['String'];
  provider?: Maybe<AccountProvider>;
  name: Scalars['String'];
}>;


export type RenameBillMutation = { __typename?: 'Mutation', renameBill: (
    { __typename?: 'Bill' }
    & FullBillFragment
  ) };

export type UpdateBillTypeMutationVariables = Exact<{
  accountId: Scalars['String'];
  provider?: Maybe<AccountProvider>;
  type: BillType;
}>;


export type UpdateBillTypeMutation = { __typename?: 'Mutation', updateBillType: (
    { __typename?: 'Bill' }
    & FullBillFragment
  ) };

export type LockEntityMutationVariables = Exact<{ [key: string]: never; }>;


export type LockEntityMutation = { __typename?: 'Mutation', lockEntityAuth: (
    { __typename?: 'MethodFiEntity' }
    & FullMethodFiEntityFragment
  ) };

export type UpdateEntityAuthenticationMutationVariables = Exact<{
  connectionId?: Maybe<Scalars['String']>;
}>;


export type UpdateEntityAuthenticationMutation = { __typename?: 'Mutation', updateEntityAuthentication?: Maybe<(
    { __typename?: 'MethodFiEntity' }
    & FullMethodFiEntityFragment
  )> };

export type CreatePaymentSubscriptionMutationVariables = Exact<{
  createSubscriptionInput: CreateSubscriptionInput;
  signatureParams?: Maybe<SignatureParamsInput>;
}>;


export type CreatePaymentSubscriptionMutation = { __typename?: 'Mutation', createSubscription: (
    { __typename?: 'PaymentSubscription' }
    & FullPaymentSubscriptionFragment
  ) };

export type FullPayableAccountFragment = { __typename?: 'PayableAccount', id: string, type: PayableAccountType, subType?: Maybe<BillType>, name: string, paymentProvider: PaymentProvider, accountProvider: AccountProvider, ownedByUser: boolean };

export type FullPaymentFragment = { __typename?: 'Payment', id: string, userId: any, status: PaymentStatus, accountId?: Maybe<any>, paymentProvider: PaymentProvider, deliveryDate?: Maybe<any>, amount?: Maybe<number>, rewardsAmount?: Maybe<number>, feeAmount?: Maybe<number>, createdAt: any, account?: Maybe<(
    { __typename?: 'PayableAccount' }
    & FullPayableAccountFragment
  )>, externalPayment?: Maybe<{ __typename?: 'ExternalPayment', amount: number, completionDate?: Maybe<any>, paymentProvider: PaymentProvider, createdAt: any }>, directPayment?: Maybe<{ __typename?: 'DirectPayment', id: string, status: DirectPaymentStatus, amount: number, testPayment?: Maybe<boolean>, transactionReferences: Array<{ __typename?: 'DirectPaymentTransactionReference', hash: string, asset?: Maybe<string>, value?: Maybe<number>, status: DirectPaymentTransactionReferenceStatus, network: string, sourceToken?: Maybe<{ __typename?: 'PaymentEventToken', symbol: string }> }> }> };

export type PaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentsQuery = { __typename?: 'Query', payments: Array<(
    { __typename?: 'Payment' }
    & FullPaymentFragment
  )> };

export type PaymentsInProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentsInProgressQuery = { __typename?: 'Query', paymentsInProgress: Array<(
    { __typename?: 'Payment' }
    & FullPaymentFragment
  )> };

export type PaymentHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentHistoryQuery = { __typename?: 'Query', paymentHistory: Array<(
    { __typename?: 'Payment' }
    & FullPaymentFragment
  )> };

export type FullDirectPaymentFragment = { __typename?: 'DirectPayment', id: string, userId: any, status: DirectPaymentStatus, amount: number, feeAmount?: Maybe<number>, amountDue: number, rewardsAmount?: Maybe<number>, totalAmount: number, accountId: any, toAddress: string, tokenAddress: string, network: string, transactionReferences: Array<{ __typename?: 'DirectPaymentTransactionReference', hash: string, asset?: Maybe<string>, value?: Maybe<number>, status: DirectPaymentTransactionReferenceStatus, network: string }> };

export type DirectPaymentQueryVariables = Exact<{
  paymentId: Scalars['String'];
}>;


export type DirectPaymentQuery = { __typename?: 'Query', directPayment?: Maybe<(
    { __typename?: 'DirectPayment', account: (
      { __typename?: 'PayableAccount' }
      & FullPayableAccountFragment
    ) }
    & FullDirectPaymentFragment
  )> };

export type CreateDirectPaymentMutationVariables = Exact<{
  createDirectPaymentInput: CreateDirectPaymentInput;
}>;


export type CreateDirectPaymentMutation = { __typename?: 'Mutation', createDirectPayment: (
    { __typename?: 'DirectPayment', currentTime?: Maybe<any>, account: (
      { __typename?: 'PayableAccount' }
      & FullPayableAccountFragment
    ) }
    & FullDirectPaymentFragment
  ) };

export type TransactionPriceQueryVariables = Exact<{
  amount: Scalars['Float'];
}>;


export type TransactionPriceQuery = { __typename?: 'Query', transactionPrice: number };

export type DeleteSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type DeleteSubscriptionMutation = { __typename?: 'Mutation', deleteSubscription: boolean };

export type RetrySubscriptionChargeMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type RetrySubscriptionChargeMutation = { __typename?: 'Mutation', retrySubscriptionCharge: boolean };

export type FullUserFragment = { __typename?: 'User', id: string, sub: string, email: string, firstName?: Maybe<string>, lastName?: Maybe<string>, picture?: Maybe<string>, phone?: Maybe<string>, createdAt: any, timezone: string, onboardingStatus: OnboardingStatus, appDomain?: Maybe<AppDomain>, attributionSource?: Maybe<string> };

export type CurrentUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserDataQuery = { __typename?: 'Query', growsurfSecret?: Maybe<string>, rewardsBalance: number, me: (
    { __typename?: 'User' }
    & FullUserFragment
  ), growsurfParticipant?: Maybe<{ __typename?: 'GrowsurfParticipant', id: string, referralCount: number, referralSource: string, referralStatus?: Maybe<string> }> };

export type CreateGrowsurfParticipantMutationVariables = Exact<{
  referrerId?: Maybe<Scalars['String']>;
}>;


export type CreateGrowsurfParticipantMutation = { __typename?: 'Mutation', createGrowsurfParticipant?: Maybe<{ __typename?: 'GrowsurfParticipant', id: string, referralCount: number, referralSource: string, referralStatus?: Maybe<string> }> };

export type RewardsBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type RewardsBalanceQuery = { __typename?: 'Query', rewardsBalance: number };

export type ReferralStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralStatsQuery = { __typename?: 'Query', referralStats?: Maybe<{ __typename?: 'GrowsurfReferralStats', id: string, rewardsEarned: number, signups: number, qualifiedReferrals: number }> };

export type UpdateCurrentUserMutationVariables = Exact<{
  userUpdate: UpdateCurrentUserInput;
}>;


export type UpdateCurrentUserMutation = { __typename?: 'Mutation', updateCurrentUser: (
    { __typename?: 'User' }
    & FullUserFragment
  ) };

export type UpdateOnboardingStatusMutationVariables = Exact<{
  status: OnboardingStatus;
}>;


export type UpdateOnboardingStatusMutation = { __typename?: 'Mutation', updateOnboardingStatus: (
    { __typename?: 'User' }
    & FullUserFragment
  ) };

export type UpdateUserTimezoneMutationVariables = Exact<{
  timezone: Scalars['String'];
}>;


export type UpdateUserTimezoneMutation = { __typename?: 'Mutation', updateUserTimezone: (
    { __typename?: 'User' }
    & FullUserFragment
  ) };

export type UpdateAppDomainMutationVariables = Exact<{
  appDomain: AppDomain;
}>;


export type UpdateAppDomainMutation = { __typename?: 'Mutation', updateAppDomain: boolean };

export type UpdateAttributionSourceMutationVariables = Exact<{
  attributionSource: Scalars['String'];
}>;


export type UpdateAttributionSourceMutation = { __typename?: 'Mutation', updateAttributionSource?: Maybe<(
    { __typename?: 'User' }
    & FullUserFragment
  )> };

export type AddAssociatedWalletMutationVariables = Exact<{
  address: Scalars['String'];
}>;


export type AddAssociatedWalletMutation = { __typename?: 'Mutation', addAssociatedWallet: boolean };

export type AddAffiliateReferralCodeMutationVariables = Exact<{
  referralCode: Scalars['String'];
}>;


export type AddAffiliateReferralCodeMutation = { __typename?: 'Mutation', addAffiliateReferralCode: boolean };

export type KycStatusBriefFragment = { __typename?: 'KycStatus', id: string, signature: string, cognitoKycFlow?: Maybe<{ __typename?: 'CognitoKycFlow', id: string, status: string, userCompleted: boolean, completed_at?: Maybe<string> }> };

export type KycStatusSetUserCompletedMutationVariables = Exact<{ [key: string]: never; }>;


export type KycStatusSetUserCompletedMutation = { __typename?: 'Mutation', kycStatusSetUserCompleted: (
    { __typename?: 'KycStatus' }
    & KycStatusBriefFragment
  ) };

export type UpdateMethodfiSsnMutationVariables = Exact<{
  ssn: Scalars['String'];
}>;


export type UpdateMethodfiSsnMutation = { __typename?: 'Mutation', methodFiUpdateSSN: (
    { __typename?: 'MethodFiEntity' }
    & FullMethodFiEntityFragment
  ) };

export type VerificationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type VerificationDataQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, kycStatus: (
      { __typename?: 'KycStatus' }
      & KycStatusBriefFragment
    ), methodFiEntity?: Maybe<(
      { __typename?: 'MethodFiEntity' }
      & FullMethodFiEntityFragment
    )> } };

export const FullTokenBalanceFragmentDoc = gql`
    fragment FullTokenBalance on TokenBalance {
  address
  walletAddress
  symbol
  network
  decimals
  balance
  balanceRaw
  balanceUSD
  price
  tokenImageUrl
}
    `;
export const FullBankAccountFragmentDoc = gql`
    fragment FullBankAccount on CheckbookAccount {
  id
  userId
  type
  email
  holder
  name
  accountNumber
  routingNumber
  ownedByUser
  institution {
    logo
    name
  }
}
    `;
export const FullSpritzCardFragmentDoc = gql`
    fragment FullSpritzCard on CheckbookVirtualCard {
  renderSecret
  externalId
  id
  mask
  balance
  holderDetails {
    firstName
    lastName
    phone
    address {
      zip
      state
      city
      line_1
    }
  }
}
    `;
export const FullMethodFiEntityFragmentDoc = gql`
    fragment FullMethodFiEntity on MethodFiEntity {
  id
  canReceive
  canRetrieveData
  authenticated
  locked
  active
  error
  status
  address {
    zip
  }
}
    `;
export const MerchantSummaryFragmentDoc = gql`
    fragment MerchantSummary on MethodFiMerchant {
  id
  name
  parentName
  logo
  description
  types
}
    `;
export const InstitutionFragmentDoc = gql`
    fragment Institution on BillInstitution {
  id
  institutionId
  logo
  logoUrl
  name
}
    `;
export const FullBillFragmentDoc = gql`
    fragment FullBill on Bill {
  id
  accountId
  provider
  connected
  verified
  mask
  type
  name
  originalName
  manual
  canReceive
  balance
  openedAt
  nextPaymentDueDate
  amountDue
  syncStatus
  lastSync
  createdAt
  testPaymentAvailable
  institution {
    ...Institution
  }
}
    ${InstitutionFragmentDoc}`;
export const FullPaymentSubscriptionFragmentDoc = gql`
    fragment FullPaymentSubscription on PaymentSubscription {
  id
  accountId
  provider
  type
  amount
  network
  startDate
  nextSubscriptionDate
  frequency
  frequencyValue
  blockchainSubscriptionId
  walletAddress
  paymentToken
  tokenSymbol
  subscriptionCount
  totalPayments
  processing
  error {
    type
    retryCount
    nextRetry
  }
}
    `;
export const FullPopularBillFragmentDoc = gql`
    fragment FullPopularBill on PopularBill {
  id
  name
  count
  type
  institution {
    ...Institution
  }
}
    ${InstitutionFragmentDoc}`;
export const FullPayableAccountFragmentDoc = gql`
    fragment FullPayableAccount on PayableAccount {
  id
  type
  subType
  name
  paymentProvider
  accountProvider
  ownedByUser
}
    `;
export const FullPaymentFragmentDoc = gql`
    fragment FullPayment on Payment {
  id
  userId
  status
  accountId
  paymentProvider
  deliveryDate
  amount
  rewardsAmount
  feeAmount
  createdAt
  account {
    ...FullPayableAccount
  }
  externalPayment {
    amount
    completionDate
    paymentProvider
    createdAt
  }
  directPayment {
    id
    status
    amount
    testPayment
    transactionReferences {
      hash
      asset
      value
      status
      network
      sourceToken {
        symbol
      }
    }
  }
}
    ${FullPayableAccountFragmentDoc}`;
export const FullDirectPaymentFragmentDoc = gql`
    fragment FullDirectPayment on DirectPayment {
  id
  userId
  status
  userId
  amount
  feeAmount
  amountDue
  rewardsAmount
  totalAmount
  accountId
  toAddress
  tokenAddress
  totalAmount
  network
  transactionReferences {
    hash
    asset
    value
    status
    network
  }
}
    `;
export const FullUserFragmentDoc = gql`
    fragment FullUser on User {
  id
  sub
  email
  firstName
  lastName
  picture
  phone
  createdAt
  timezone
  onboardingStatus
  appDomain
  attributionSource
}
    `;
export const KycStatusBriefFragmentDoc = gql`
    fragment KycStatusBrief on KycStatus {
  id
  signature
  cognitoKycFlow {
    id
    status
    userCompleted
    completed_at
  }
}
    `;
export const GetWalletTokenBalancesDocument = gql`
    query GetWalletTokenBalances($address: String!, $network: String) {
  tokenBalances(address: $address, network: $network) {
    ...FullTokenBalance
  }
}
    ${FullTokenBalanceFragmentDoc}`;

/**
 * __useGetWalletTokenBalancesQuery__
 *
 * To run a query within a React component, call `useGetWalletTokenBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletTokenBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletTokenBalancesQuery({
 *   variables: {
 *      address: // value for 'address'
 *      network: // value for 'network'
 *   },
 * });
 */
export function useGetWalletTokenBalancesQuery(baseOptions: Apollo.QueryHookOptions<GetWalletTokenBalancesQuery, GetWalletTokenBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletTokenBalancesQuery, GetWalletTokenBalancesQueryVariables>(GetWalletTokenBalancesDocument, options);
      }
export function useGetWalletTokenBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletTokenBalancesQuery, GetWalletTokenBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletTokenBalancesQuery, GetWalletTokenBalancesQueryVariables>(GetWalletTokenBalancesDocument, options);
        }
export type GetWalletTokenBalancesQueryHookResult = ReturnType<typeof useGetWalletTokenBalancesQuery>;
export type GetWalletTokenBalancesLazyQueryHookResult = ReturnType<typeof useGetWalletTokenBalancesLazyQuery>;
export type GetWalletTokenBalancesQueryResult = Apollo.QueryResult<GetWalletTokenBalancesQuery, GetWalletTokenBalancesQueryVariables>;
export function refetchGetWalletTokenBalancesQuery(variables?: GetWalletTokenBalancesQueryVariables) {
      return { query: GetWalletTokenBalancesDocument, variables: variables }
    }
export const FlushBalancesDocument = gql`
    mutation FlushBalances($addresses: [String!]!) {
  flushBalances(addresses: $addresses) {
    ...FullTokenBalance
  }
}
    ${FullTokenBalanceFragmentDoc}`;
export type FlushBalancesMutationFn = Apollo.MutationFunction<FlushBalancesMutation, FlushBalancesMutationVariables>;

/**
 * __useFlushBalancesMutation__
 *
 * To run a mutation, you first call `useFlushBalancesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlushBalancesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flushBalancesMutation, { data, loading, error }] = useFlushBalancesMutation({
 *   variables: {
 *      addresses: // value for 'addresses'
 *   },
 * });
 */
export function useFlushBalancesMutation(baseOptions?: Apollo.MutationHookOptions<FlushBalancesMutation, FlushBalancesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlushBalancesMutation, FlushBalancesMutationVariables>(FlushBalancesDocument, options);
      }
export type FlushBalancesMutationHookResult = ReturnType<typeof useFlushBalancesMutation>;
export type FlushBalancesMutationResult = Apollo.MutationResult<FlushBalancesMutation>;
export type FlushBalancesMutationOptions = Apollo.BaseMutationOptions<FlushBalancesMutation, FlushBalancesMutationVariables>;
export const GetBalancesDocument = gql`
    query GetBalances($address: String!, $network: String, $paymentLimitsInput: PaymentLimitsInput!) {
  tokenBalances(address: $address, network: $network) {
    ...FullTokenBalance
  }
  rewardsBalance
  sdkConfig
  paymentLimits(paymentLimitsInput: $paymentLimitsInput) {
    absolute
    delay
  }
}
    ${FullTokenBalanceFragmentDoc}`;

/**
 * __useGetBalancesQuery__
 *
 * To run a query within a React component, call `useGetBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBalancesQuery({
 *   variables: {
 *      address: // value for 'address'
 *      network: // value for 'network'
 *      paymentLimitsInput: // value for 'paymentLimitsInput'
 *   },
 * });
 */
export function useGetBalancesQuery(baseOptions: Apollo.QueryHookOptions<GetBalancesQuery, GetBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBalancesQuery, GetBalancesQueryVariables>(GetBalancesDocument, options);
      }
export function useGetBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBalancesQuery, GetBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBalancesQuery, GetBalancesQueryVariables>(GetBalancesDocument, options);
        }
export type GetBalancesQueryHookResult = ReturnType<typeof useGetBalancesQuery>;
export type GetBalancesLazyQueryHookResult = ReturnType<typeof useGetBalancesLazyQuery>;
export type GetBalancesQueryResult = Apollo.QueryResult<GetBalancesQuery, GetBalancesQueryVariables>;
export function refetchGetBalancesQuery(variables?: GetBalancesQueryVariables) {
      return { query: GetBalancesDocument, variables: variables }
    }
export const BankAccountsDocument = gql`
    query BankAccounts {
  bankAccounts {
    ...FullBankAccount
  }
}
    ${FullBankAccountFragmentDoc}`;

/**
 * __useBankAccountsQuery__
 *
 * To run a query within a React component, call `useBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankAccountsQuery(baseOptions?: Apollo.QueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
      }
export function useBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
        }
export type BankAccountsQueryHookResult = ReturnType<typeof useBankAccountsQuery>;
export type BankAccountsLazyQueryHookResult = ReturnType<typeof useBankAccountsLazyQuery>;
export type BankAccountsQueryResult = Apollo.QueryResult<BankAccountsQuery, BankAccountsQueryVariables>;
export function refetchBankAccountsQuery(variables?: BankAccountsQueryVariables) {
      return { query: BankAccountsDocument, variables: variables }
    }
export const LookupInstitutionDocument = gql`
    query LookupInstitution($routingNumber: String!) {
  achInstitution(routingNumber: $routingNumber) {
    logo
    name
    isRTPEnabled
  }
}
    `;

/**
 * __useLookupInstitutionQuery__
 *
 * To run a query within a React component, call `useLookupInstitutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupInstitutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupInstitutionQuery({
 *   variables: {
 *      routingNumber: // value for 'routingNumber'
 *   },
 * });
 */
export function useLookupInstitutionQuery(baseOptions: Apollo.QueryHookOptions<LookupInstitutionQuery, LookupInstitutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupInstitutionQuery, LookupInstitutionQueryVariables>(LookupInstitutionDocument, options);
      }
export function useLookupInstitutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupInstitutionQuery, LookupInstitutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupInstitutionQuery, LookupInstitutionQueryVariables>(LookupInstitutionDocument, options);
        }
export type LookupInstitutionQueryHookResult = ReturnType<typeof useLookupInstitutionQuery>;
export type LookupInstitutionLazyQueryHookResult = ReturnType<typeof useLookupInstitutionLazyQuery>;
export type LookupInstitutionQueryResult = Apollo.QueryResult<LookupInstitutionQuery, LookupInstitutionQueryVariables>;
export function refetchLookupInstitutionQuery(variables?: LookupInstitutionQueryVariables) {
      return { query: LookupInstitutionDocument, variables: variables }
    }
export const AddBankAccountDocument = gql`
    mutation AddBankAccount($createAccountInput: CreateAccountInput!) {
  createCheckbookAccount(createAccountInput: $createAccountInput) {
    ...FullBankAccount
  }
}
    ${FullBankAccountFragmentDoc}`;
export type AddBankAccountMutationFn = Apollo.MutationFunction<AddBankAccountMutation, AddBankAccountMutationVariables>;

/**
 * __useAddBankAccountMutation__
 *
 * To run a mutation, you first call `useAddBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBankAccountMutation, { data, loading, error }] = useAddBankAccountMutation({
 *   variables: {
 *      createAccountInput: // value for 'createAccountInput'
 *   },
 * });
 */
export function useAddBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddBankAccountMutation, AddBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBankAccountMutation, AddBankAccountMutationVariables>(AddBankAccountDocument, options);
      }
export type AddBankAccountMutationHookResult = ReturnType<typeof useAddBankAccountMutation>;
export type AddBankAccountMutationResult = Apollo.MutationResult<AddBankAccountMutation>;
export type AddBankAccountMutationOptions = Apollo.BaseMutationOptions<AddBankAccountMutation, AddBankAccountMutationVariables>;
export const DeleteBankAccountDocument = gql`
    mutation DeleteBankAccount($accountId: String!) {
  deleteCheckbookAccount(accountId: $accountId) {
    ...FullBankAccount
  }
}
    ${FullBankAccountFragmentDoc}`;
export type DeleteBankAccountMutationFn = Apollo.MutationFunction<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>;

/**
 * __useDeleteBankAccountMutation__
 *
 * To run a mutation, you first call `useDeleteBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBankAccountMutation, { data, loading, error }] = useDeleteBankAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>(DeleteBankAccountDocument, options);
      }
export type DeleteBankAccountMutationHookResult = ReturnType<typeof useDeleteBankAccountMutation>;
export type DeleteBankAccountMutationResult = Apollo.MutationResult<DeleteBankAccountMutation>;
export type DeleteBankAccountMutationOptions = Apollo.BaseMutationOptions<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>;
export const RenameBankAccountDocument = gql`
    mutation RenameBankAccount($accountId: String!, $name: String!) {
  renameCheckbookAccount(accountId: $accountId, name: $name) {
    ...FullBankAccount
  }
}
    ${FullBankAccountFragmentDoc}`;
export type RenameBankAccountMutationFn = Apollo.MutationFunction<RenameBankAccountMutation, RenameBankAccountMutationVariables>;

/**
 * __useRenameBankAccountMutation__
 *
 * To run a mutation, you first call `useRenameBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameBankAccountMutation, { data, loading, error }] = useRenameBankAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<RenameBankAccountMutation, RenameBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameBankAccountMutation, RenameBankAccountMutationVariables>(RenameBankAccountDocument, options);
      }
export type RenameBankAccountMutationHookResult = ReturnType<typeof useRenameBankAccountMutation>;
export type RenameBankAccountMutationResult = Apollo.MutationResult<RenameBankAccountMutation>;
export type RenameBankAccountMutationOptions = Apollo.BaseMutationOptions<RenameBankAccountMutation, RenameBankAccountMutationVariables>;
export const SpritzCardDocument = gql`
    query SpritzCard {
  virtualCard {
    ...FullSpritzCard
  }
}
    ${FullSpritzCardFragmentDoc}`;

/**
 * __useSpritzCardQuery__
 *
 * To run a query within a React component, call `useSpritzCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpritzCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpritzCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpritzCardQuery(baseOptions?: Apollo.QueryHookOptions<SpritzCardQuery, SpritzCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpritzCardQuery, SpritzCardQueryVariables>(SpritzCardDocument, options);
      }
export function useSpritzCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpritzCardQuery, SpritzCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpritzCardQuery, SpritzCardQueryVariables>(SpritzCardDocument, options);
        }
export type SpritzCardQueryHookResult = ReturnType<typeof useSpritzCardQuery>;
export type SpritzCardLazyQueryHookResult = ReturnType<typeof useSpritzCardLazyQuery>;
export type SpritzCardQueryResult = Apollo.QueryResult<SpritzCardQuery, SpritzCardQueryVariables>;
export function refetchSpritzCardQuery(variables?: SpritzCardQueryVariables) {
      return { query: SpritzCardDocument, variables: variables }
    }
export const CreateSpritzCardDocument = gql`
    mutation CreateSpritzCard {
  createVirtualCard {
    ...FullSpritzCard
  }
}
    ${FullSpritzCardFragmentDoc}`;
export type CreateSpritzCardMutationFn = Apollo.MutationFunction<CreateSpritzCardMutation, CreateSpritzCardMutationVariables>;

/**
 * __useCreateSpritzCardMutation__
 *
 * To run a mutation, you first call `useCreateSpritzCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpritzCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpritzCardMutation, { data, loading, error }] = useCreateSpritzCardMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSpritzCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateSpritzCardMutation, CreateSpritzCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSpritzCardMutation, CreateSpritzCardMutationVariables>(CreateSpritzCardDocument, options);
      }
export type CreateSpritzCardMutationHookResult = ReturnType<typeof useCreateSpritzCardMutation>;
export type CreateSpritzCardMutationResult = Apollo.MutationResult<CreateSpritzCardMutation>;
export type CreateSpritzCardMutationOptions = Apollo.BaseMutationOptions<CreateSpritzCardMutation, CreateSpritzCardMutationVariables>;
export const GasPriceDocument = gql`
    query GasPrice($network: String!) {
  gasPrice(network: $network) {
    network
    lastBlock
    speeds {
      instant
      fast
      standard
    }
  }
}
    `;

/**
 * __useGasPriceQuery__
 *
 * To run a query within a React component, call `useGasPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGasPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGasPriceQuery({
 *   variables: {
 *      network: // value for 'network'
 *   },
 * });
 */
export function useGasPriceQuery(baseOptions: Apollo.QueryHookOptions<GasPriceQuery, GasPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GasPriceQuery, GasPriceQueryVariables>(GasPriceDocument, options);
      }
export function useGasPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GasPriceQuery, GasPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GasPriceQuery, GasPriceQueryVariables>(GasPriceDocument, options);
        }
export type GasPriceQueryHookResult = ReturnType<typeof useGasPriceQuery>;
export type GasPriceLazyQueryHookResult = ReturnType<typeof useGasPriceLazyQuery>;
export type GasPriceQueryResult = Apollo.QueryResult<GasPriceQuery, GasPriceQueryVariables>;
export function refetchGasPriceQuery(variables?: GasPriceQueryVariables) {
      return { query: GasPriceDocument, variables: variables }
    }
export const CanAddBillsDocument = gql`
    query CanAddBills {
  me {
    id
    kycStatus {
      ...KycStatusBrief
    }
    methodFiEntity {
      ...FullMethodFiEntity
    }
  }
}
    ${KycStatusBriefFragmentDoc}
${FullMethodFiEntityFragmentDoc}`;

/**
 * __useCanAddBillsQuery__
 *
 * To run a query within a React component, call `useCanAddBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanAddBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanAddBillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanAddBillsQuery(baseOptions?: Apollo.QueryHookOptions<CanAddBillsQuery, CanAddBillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanAddBillsQuery, CanAddBillsQueryVariables>(CanAddBillsDocument, options);
      }
export function useCanAddBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanAddBillsQuery, CanAddBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanAddBillsQuery, CanAddBillsQueryVariables>(CanAddBillsDocument, options);
        }
export type CanAddBillsQueryHookResult = ReturnType<typeof useCanAddBillsQuery>;
export type CanAddBillsLazyQueryHookResult = ReturnType<typeof useCanAddBillsLazyQuery>;
export type CanAddBillsQueryResult = Apollo.QueryResult<CanAddBillsQuery, CanAddBillsQueryVariables>;
export function refetchCanAddBillsQuery(variables?: CanAddBillsQueryVariables) {
      return { query: CanAddBillsDocument, variables: variables }
    }
export const MethodFiAuthTokenDocument = gql`
    query MethodFiAuthToken {
  getMethodFiAuthToken
}
    `;

/**
 * __useMethodFiAuthTokenQuery__
 *
 * To run a query within a React component, call `useMethodFiAuthTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useMethodFiAuthTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMethodFiAuthTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useMethodFiAuthTokenQuery(baseOptions?: Apollo.QueryHookOptions<MethodFiAuthTokenQuery, MethodFiAuthTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MethodFiAuthTokenQuery, MethodFiAuthTokenQueryVariables>(MethodFiAuthTokenDocument, options);
      }
export function useMethodFiAuthTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MethodFiAuthTokenQuery, MethodFiAuthTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MethodFiAuthTokenQuery, MethodFiAuthTokenQueryVariables>(MethodFiAuthTokenDocument, options);
        }
export type MethodFiAuthTokenQueryHookResult = ReturnType<typeof useMethodFiAuthTokenQuery>;
export type MethodFiAuthTokenLazyQueryHookResult = ReturnType<typeof useMethodFiAuthTokenLazyQuery>;
export type MethodFiAuthTokenQueryResult = Apollo.QueryResult<MethodFiAuthTokenQuery, MethodFiAuthTokenQueryVariables>;
export function refetchMethodFiAuthTokenQuery(variables?: MethodFiAuthTokenQueryVariables) {
      return { query: MethodFiAuthTokenDocument, variables: variables }
    }
export const BillConnectionDataDocument = gql`
    query BillConnectionData {
  methodFiEntity {
    ...FullMethodFiEntity
  }
}
    ${FullMethodFiEntityFragmentDoc}`;

/**
 * __useBillConnectionDataQuery__
 *
 * To run a query within a React component, call `useBillConnectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillConnectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillConnectionDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillConnectionDataQuery(baseOptions?: Apollo.QueryHookOptions<BillConnectionDataQuery, BillConnectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillConnectionDataQuery, BillConnectionDataQueryVariables>(BillConnectionDataDocument, options);
      }
export function useBillConnectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillConnectionDataQuery, BillConnectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillConnectionDataQuery, BillConnectionDataQueryVariables>(BillConnectionDataDocument, options);
        }
export type BillConnectionDataQueryHookResult = ReturnType<typeof useBillConnectionDataQuery>;
export type BillConnectionDataLazyQueryHookResult = ReturnType<typeof useBillConnectionDataLazyQuery>;
export type BillConnectionDataQueryResult = Apollo.QueryResult<BillConnectionDataQuery, BillConnectionDataQueryVariables>;
export function refetchBillConnectionDataQuery(variables?: BillConnectionDataQueryVariables) {
      return { query: BillConnectionDataDocument, variables: variables }
    }
export const AddCustomBillDocument = gql`
    mutation AddCustomBill($merchantId: String!, $accountId: String!, $type: BillType) {
  addAccount(merchantId: $merchantId, accountId: $accountId, type: $type) {
    id
    nickname
    manual
    capabilities
  }
}
    `;
export type AddCustomBillMutationFn = Apollo.MutationFunction<AddCustomBillMutation, AddCustomBillMutationVariables>;

/**
 * __useAddCustomBillMutation__
 *
 * To run a mutation, you first call `useAddCustomBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomBillMutation, { data, loading, error }] = useAddCustomBillMutation({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *      accountId: // value for 'accountId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddCustomBillMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomBillMutation, AddCustomBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomBillMutation, AddCustomBillMutationVariables>(AddCustomBillDocument, options);
      }
export type AddCustomBillMutationHookResult = ReturnType<typeof useAddCustomBillMutation>;
export type AddCustomBillMutationResult = Apollo.MutationResult<AddCustomBillMutation>;
export type AddCustomBillMutationOptions = Apollo.BaseMutationOptions<AddCustomBillMutation, AddCustomBillMutationVariables>;
export const MerchantsDocument = gql`
    query Merchants($name: String, $type: BillType) {
  merchants(name: $name, type: $type) {
    ...MerchantSummary
  }
}
    ${MerchantSummaryFragmentDoc}`;

/**
 * __useMerchantsQuery__
 *
 * To run a query within a React component, call `useMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useMerchantsQuery(baseOptions?: Apollo.QueryHookOptions<MerchantsQuery, MerchantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantsQuery, MerchantsQueryVariables>(MerchantsDocument, options);
      }
export function useMerchantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantsQuery, MerchantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantsQuery, MerchantsQueryVariables>(MerchantsDocument, options);
        }
export type MerchantsQueryHookResult = ReturnType<typeof useMerchantsQuery>;
export type MerchantsLazyQueryHookResult = ReturnType<typeof useMerchantsLazyQuery>;
export type MerchantsQueryResult = Apollo.QueryResult<MerchantsQuery, MerchantsQueryVariables>;
export function refetchMerchantsQuery(variables?: MerchantsQueryVariables) {
      return { query: MerchantsDocument, variables: variables }
    }
export const PopularMerchantsDocument = gql`
    query PopularMerchants($type: BillType) {
  popularMerchants(type: $type) {
    ...MerchantSummary
  }
}
    ${MerchantSummaryFragmentDoc}`;

/**
 * __usePopularMerchantsQuery__
 *
 * To run a query within a React component, call `usePopularMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularMerchantsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePopularMerchantsQuery(baseOptions?: Apollo.QueryHookOptions<PopularMerchantsQuery, PopularMerchantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularMerchantsQuery, PopularMerchantsQueryVariables>(PopularMerchantsDocument, options);
      }
export function usePopularMerchantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularMerchantsQuery, PopularMerchantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularMerchantsQuery, PopularMerchantsQueryVariables>(PopularMerchantsDocument, options);
        }
export type PopularMerchantsQueryHookResult = ReturnType<typeof usePopularMerchantsQuery>;
export type PopularMerchantsLazyQueryHookResult = ReturnType<typeof usePopularMerchantsLazyQuery>;
export type PopularMerchantsQueryResult = Apollo.QueryResult<PopularMerchantsQuery, PopularMerchantsQueryVariables>;
export function refetchPopularMerchantsQuery(variables?: PopularMerchantsQueryVariables) {
      return { query: PopularMerchantsDocument, variables: variables }
    }
export const PopularBillsDocument = gql`
    query PopularBills {
  popularBills {
    ...FullPopularBill
  }
}
    ${FullPopularBillFragmentDoc}`;

/**
 * __usePopularBillsQuery__
 *
 * To run a query within a React component, call `usePopularBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularBillsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePopularBillsQuery(baseOptions?: Apollo.QueryHookOptions<PopularBillsQuery, PopularBillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularBillsQuery, PopularBillsQueryVariables>(PopularBillsDocument, options);
      }
export function usePopularBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularBillsQuery, PopularBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularBillsQuery, PopularBillsQueryVariables>(PopularBillsDocument, options);
        }
export type PopularBillsQueryHookResult = ReturnType<typeof usePopularBillsQuery>;
export type PopularBillsLazyQueryHookResult = ReturnType<typeof usePopularBillsLazyQuery>;
export type PopularBillsQueryResult = Apollo.QueryResult<PopularBillsQuery, PopularBillsQueryVariables>;
export function refetchPopularBillsQuery(variables?: PopularBillsQueryVariables) {
      return { query: PopularBillsDocument, variables: variables }
    }
export const BillsDataDocument = gql`
    query BillsData {
  bills {
    ...FullBill
  }
  subscriptions {
    ...FullPaymentSubscription
  }
  bankAccounts(ownedByUser: false) {
    ...FullBankAccount
  }
}
    ${FullBillFragmentDoc}
${FullPaymentSubscriptionFragmentDoc}
${FullBankAccountFragmentDoc}`;

/**
 * __useBillsDataQuery__
 *
 * To run a query within a React component, call `useBillsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillsDataQuery(baseOptions?: Apollo.QueryHookOptions<BillsDataQuery, BillsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillsDataQuery, BillsDataQueryVariables>(BillsDataDocument, options);
      }
export function useBillsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillsDataQuery, BillsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillsDataQuery, BillsDataQueryVariables>(BillsDataDocument, options);
        }
export type BillsDataQueryHookResult = ReturnType<typeof useBillsDataQuery>;
export type BillsDataLazyQueryHookResult = ReturnType<typeof useBillsDataLazyQuery>;
export type BillsDataQueryResult = Apollo.QueryResult<BillsDataQuery, BillsDataQueryVariables>;
export function refetchBillsDataQuery(variables?: BillsDataQueryVariables) {
      return { query: BillsDataDocument, variables: variables }
    }
export const ConnectBillsDocument = gql`
    mutation ConnectBills($accountIds: [String!]!) {
  connectBills(accountIds: $accountIds)
}
    `;
export type ConnectBillsMutationFn = Apollo.MutationFunction<ConnectBillsMutation, ConnectBillsMutationVariables>;

/**
 * __useConnectBillsMutation__
 *
 * To run a mutation, you first call `useConnectBillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectBillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectBillsMutation, { data, loading, error }] = useConnectBillsMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useConnectBillsMutation(baseOptions?: Apollo.MutationHookOptions<ConnectBillsMutation, ConnectBillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectBillsMutation, ConnectBillsMutationVariables>(ConnectBillsDocument, options);
      }
export type ConnectBillsMutationHookResult = ReturnType<typeof useConnectBillsMutation>;
export type ConnectBillsMutationResult = Apollo.MutationResult<ConnectBillsMutation>;
export type ConnectBillsMutationOptions = Apollo.BaseMutationOptions<ConnectBillsMutation, ConnectBillsMutationVariables>;
export const DeleteBillDocument = gql`
    mutation DeleteBill($accountId: String!, $provider: AccountProvider) {
  deleteBill(accountId: $accountId, provider: $provider)
}
    `;
export type DeleteBillMutationFn = Apollo.MutationFunction<DeleteBillMutation, DeleteBillMutationVariables>;

/**
 * __useDeleteBillMutation__
 *
 * To run a mutation, you first call `useDeleteBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillMutation, { data, loading, error }] = useDeleteBillMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useDeleteBillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBillMutation, DeleteBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBillMutation, DeleteBillMutationVariables>(DeleteBillDocument, options);
      }
export type DeleteBillMutationHookResult = ReturnType<typeof useDeleteBillMutation>;
export type DeleteBillMutationResult = Apollo.MutationResult<DeleteBillMutation>;
export type DeleteBillMutationOptions = Apollo.BaseMutationOptions<DeleteBillMutation, DeleteBillMutationVariables>;
export const RenameBillDocument = gql`
    mutation RenameBill($accountId: String!, $provider: AccountProvider, $name: String!) {
  renameBill(accountId: $accountId, provider: $provider, name: $name) {
    ...FullBill
  }
}
    ${FullBillFragmentDoc}`;
export type RenameBillMutationFn = Apollo.MutationFunction<RenameBillMutation, RenameBillMutationVariables>;

/**
 * __useRenameBillMutation__
 *
 * To run a mutation, you first call `useRenameBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameBillMutation, { data, loading, error }] = useRenameBillMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      provider: // value for 'provider'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameBillMutation(baseOptions?: Apollo.MutationHookOptions<RenameBillMutation, RenameBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameBillMutation, RenameBillMutationVariables>(RenameBillDocument, options);
      }
export type RenameBillMutationHookResult = ReturnType<typeof useRenameBillMutation>;
export type RenameBillMutationResult = Apollo.MutationResult<RenameBillMutation>;
export type RenameBillMutationOptions = Apollo.BaseMutationOptions<RenameBillMutation, RenameBillMutationVariables>;
export const UpdateBillTypeDocument = gql`
    mutation UpdateBillType($accountId: String!, $provider: AccountProvider, $type: BillType!) {
  updateBillType(accountId: $accountId, provider: $provider, type: $type) {
    ...FullBill
  }
}
    ${FullBillFragmentDoc}`;
export type UpdateBillTypeMutationFn = Apollo.MutationFunction<UpdateBillTypeMutation, UpdateBillTypeMutationVariables>;

/**
 * __useUpdateBillTypeMutation__
 *
 * To run a mutation, you first call `useUpdateBillTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillTypeMutation, { data, loading, error }] = useUpdateBillTypeMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      provider: // value for 'provider'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateBillTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillTypeMutation, UpdateBillTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillTypeMutation, UpdateBillTypeMutationVariables>(UpdateBillTypeDocument, options);
      }
export type UpdateBillTypeMutationHookResult = ReturnType<typeof useUpdateBillTypeMutation>;
export type UpdateBillTypeMutationResult = Apollo.MutationResult<UpdateBillTypeMutation>;
export type UpdateBillTypeMutationOptions = Apollo.BaseMutationOptions<UpdateBillTypeMutation, UpdateBillTypeMutationVariables>;
export const LockEntityDocument = gql`
    mutation LockEntity {
  lockEntityAuth {
    ...FullMethodFiEntity
  }
}
    ${FullMethodFiEntityFragmentDoc}`;
export type LockEntityMutationFn = Apollo.MutationFunction<LockEntityMutation, LockEntityMutationVariables>;

/**
 * __useLockEntityMutation__
 *
 * To run a mutation, you first call `useLockEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockEntityMutation, { data, loading, error }] = useLockEntityMutation({
 *   variables: {
 *   },
 * });
 */
export function useLockEntityMutation(baseOptions?: Apollo.MutationHookOptions<LockEntityMutation, LockEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockEntityMutation, LockEntityMutationVariables>(LockEntityDocument, options);
      }
export type LockEntityMutationHookResult = ReturnType<typeof useLockEntityMutation>;
export type LockEntityMutationResult = Apollo.MutationResult<LockEntityMutation>;
export type LockEntityMutationOptions = Apollo.BaseMutationOptions<LockEntityMutation, LockEntityMutationVariables>;
export const UpdateEntityAuthenticationDocument = gql`
    mutation UpdateEntityAuthentication($connectionId: String) {
  updateEntityAuthentication(connectionId: $connectionId) {
    ...FullMethodFiEntity
  }
}
    ${FullMethodFiEntityFragmentDoc}`;
export type UpdateEntityAuthenticationMutationFn = Apollo.MutationFunction<UpdateEntityAuthenticationMutation, UpdateEntityAuthenticationMutationVariables>;

/**
 * __useUpdateEntityAuthenticationMutation__
 *
 * To run a mutation, you first call `useUpdateEntityAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityAuthenticationMutation, { data, loading, error }] = useUpdateEntityAuthenticationMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useUpdateEntityAuthenticationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityAuthenticationMutation, UpdateEntityAuthenticationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityAuthenticationMutation, UpdateEntityAuthenticationMutationVariables>(UpdateEntityAuthenticationDocument, options);
      }
export type UpdateEntityAuthenticationMutationHookResult = ReturnType<typeof useUpdateEntityAuthenticationMutation>;
export type UpdateEntityAuthenticationMutationResult = Apollo.MutationResult<UpdateEntityAuthenticationMutation>;
export type UpdateEntityAuthenticationMutationOptions = Apollo.BaseMutationOptions<UpdateEntityAuthenticationMutation, UpdateEntityAuthenticationMutationVariables>;
export const CreatePaymentSubscriptionDocument = gql`
    mutation CreatePaymentSubscription($createSubscriptionInput: CreateSubscriptionInput!, $signatureParams: SignatureParamsInput) {
  createSubscription(
    createSubscriptionInput: $createSubscriptionInput
    signatureParams: $signatureParams
  ) {
    ...FullPaymentSubscription
  }
}
    ${FullPaymentSubscriptionFragmentDoc}`;
export type CreatePaymentSubscriptionMutationFn = Apollo.MutationFunction<CreatePaymentSubscriptionMutation, CreatePaymentSubscriptionMutationVariables>;

/**
 * __useCreatePaymentSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreatePaymentSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentSubscriptionMutation, { data, loading, error }] = useCreatePaymentSubscriptionMutation({
 *   variables: {
 *      createSubscriptionInput: // value for 'createSubscriptionInput'
 *      signatureParams: // value for 'signatureParams'
 *   },
 * });
 */
export function useCreatePaymentSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentSubscriptionMutation, CreatePaymentSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentSubscriptionMutation, CreatePaymentSubscriptionMutationVariables>(CreatePaymentSubscriptionDocument, options);
      }
export type CreatePaymentSubscriptionMutationHookResult = ReturnType<typeof useCreatePaymentSubscriptionMutation>;
export type CreatePaymentSubscriptionMutationResult = Apollo.MutationResult<CreatePaymentSubscriptionMutation>;
export type CreatePaymentSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreatePaymentSubscriptionMutation, CreatePaymentSubscriptionMutationVariables>;
export const PaymentsDocument = gql`
    query Payments {
  payments {
    ...FullPayment
  }
}
    ${FullPaymentFragmentDoc}`;

/**
 * __usePaymentsQuery__
 *
 * To run a query within a React component, call `usePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
      }
export function usePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
export type PaymentsQueryHookResult = ReturnType<typeof usePaymentsQuery>;
export type PaymentsLazyQueryHookResult = ReturnType<typeof usePaymentsLazyQuery>;
export type PaymentsQueryResult = Apollo.QueryResult<PaymentsQuery, PaymentsQueryVariables>;
export function refetchPaymentsQuery(variables?: PaymentsQueryVariables) {
      return { query: PaymentsDocument, variables: variables }
    }
export const PaymentsInProgressDocument = gql`
    query PaymentsInProgress {
  paymentsInProgress {
    ...FullPayment
  }
}
    ${FullPaymentFragmentDoc}`;

/**
 * __usePaymentsInProgressQuery__
 *
 * To run a query within a React component, call `usePaymentsInProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsInProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsInProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentsInProgressQuery(baseOptions?: Apollo.QueryHookOptions<PaymentsInProgressQuery, PaymentsInProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsInProgressQuery, PaymentsInProgressQueryVariables>(PaymentsInProgressDocument, options);
      }
export function usePaymentsInProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsInProgressQuery, PaymentsInProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsInProgressQuery, PaymentsInProgressQueryVariables>(PaymentsInProgressDocument, options);
        }
export type PaymentsInProgressQueryHookResult = ReturnType<typeof usePaymentsInProgressQuery>;
export type PaymentsInProgressLazyQueryHookResult = ReturnType<typeof usePaymentsInProgressLazyQuery>;
export type PaymentsInProgressQueryResult = Apollo.QueryResult<PaymentsInProgressQuery, PaymentsInProgressQueryVariables>;
export function refetchPaymentsInProgressQuery(variables?: PaymentsInProgressQueryVariables) {
      return { query: PaymentsInProgressDocument, variables: variables }
    }
export const PaymentHistoryDocument = gql`
    query PaymentHistory {
  paymentHistory {
    ...FullPayment
  }
}
    ${FullPaymentFragmentDoc}`;

/**
 * __usePaymentHistoryQuery__
 *
 * To run a query within a React component, call `usePaymentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentHistoryQuery(baseOptions?: Apollo.QueryHookOptions<PaymentHistoryQuery, PaymentHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentHistoryQuery, PaymentHistoryQueryVariables>(PaymentHistoryDocument, options);
      }
export function usePaymentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentHistoryQuery, PaymentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentHistoryQuery, PaymentHistoryQueryVariables>(PaymentHistoryDocument, options);
        }
export type PaymentHistoryQueryHookResult = ReturnType<typeof usePaymentHistoryQuery>;
export type PaymentHistoryLazyQueryHookResult = ReturnType<typeof usePaymentHistoryLazyQuery>;
export type PaymentHistoryQueryResult = Apollo.QueryResult<PaymentHistoryQuery, PaymentHistoryQueryVariables>;
export function refetchPaymentHistoryQuery(variables?: PaymentHistoryQueryVariables) {
      return { query: PaymentHistoryDocument, variables: variables }
    }
export const DirectPaymentDocument = gql`
    query DirectPayment($paymentId: String!) {
  directPayment(paymentId: $paymentId) {
    ...FullDirectPayment
    account {
      ...FullPayableAccount
    }
  }
}
    ${FullDirectPaymentFragmentDoc}
${FullPayableAccountFragmentDoc}`;

/**
 * __useDirectPaymentQuery__
 *
 * To run a query within a React component, call `useDirectPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectPaymentQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useDirectPaymentQuery(baseOptions: Apollo.QueryHookOptions<DirectPaymentQuery, DirectPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectPaymentQuery, DirectPaymentQueryVariables>(DirectPaymentDocument, options);
      }
export function useDirectPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectPaymentQuery, DirectPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectPaymentQuery, DirectPaymentQueryVariables>(DirectPaymentDocument, options);
        }
export type DirectPaymentQueryHookResult = ReturnType<typeof useDirectPaymentQuery>;
export type DirectPaymentLazyQueryHookResult = ReturnType<typeof useDirectPaymentLazyQuery>;
export type DirectPaymentQueryResult = Apollo.QueryResult<DirectPaymentQuery, DirectPaymentQueryVariables>;
export function refetchDirectPaymentQuery(variables?: DirectPaymentQueryVariables) {
      return { query: DirectPaymentDocument, variables: variables }
    }
export const CreateDirectPaymentDocument = gql`
    mutation CreateDirectPayment($createDirectPaymentInput: CreateDirectPaymentInput!) {
  createDirectPayment(createDirectPaymentInput: $createDirectPaymentInput) {
    ...FullDirectPayment
    account {
      ...FullPayableAccount
    }
    currentTime
  }
}
    ${FullDirectPaymentFragmentDoc}
${FullPayableAccountFragmentDoc}`;
export type CreateDirectPaymentMutationFn = Apollo.MutationFunction<CreateDirectPaymentMutation, CreateDirectPaymentMutationVariables>;

/**
 * __useCreateDirectPaymentMutation__
 *
 * To run a mutation, you first call `useCreateDirectPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectPaymentMutation, { data, loading, error }] = useCreateDirectPaymentMutation({
 *   variables: {
 *      createDirectPaymentInput: // value for 'createDirectPaymentInput'
 *   },
 * });
 */
export function useCreateDirectPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDirectPaymentMutation, CreateDirectPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDirectPaymentMutation, CreateDirectPaymentMutationVariables>(CreateDirectPaymentDocument, options);
      }
export type CreateDirectPaymentMutationHookResult = ReturnType<typeof useCreateDirectPaymentMutation>;
export type CreateDirectPaymentMutationResult = Apollo.MutationResult<CreateDirectPaymentMutation>;
export type CreateDirectPaymentMutationOptions = Apollo.BaseMutationOptions<CreateDirectPaymentMutation, CreateDirectPaymentMutationVariables>;
export const TransactionPriceDocument = gql`
    query TransactionPrice($amount: Float!) {
  transactionPrice(amount: $amount)
}
    `;

/**
 * __useTransactionPriceQuery__
 *
 * To run a query within a React component, call `useTransactionPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionPriceQuery({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useTransactionPriceQuery(baseOptions: Apollo.QueryHookOptions<TransactionPriceQuery, TransactionPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionPriceQuery, TransactionPriceQueryVariables>(TransactionPriceDocument, options);
      }
export function useTransactionPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionPriceQuery, TransactionPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionPriceQuery, TransactionPriceQueryVariables>(TransactionPriceDocument, options);
        }
export type TransactionPriceQueryHookResult = ReturnType<typeof useTransactionPriceQuery>;
export type TransactionPriceLazyQueryHookResult = ReturnType<typeof useTransactionPriceLazyQuery>;
export type TransactionPriceQueryResult = Apollo.QueryResult<TransactionPriceQuery, TransactionPriceQueryVariables>;
export function refetchTransactionPriceQuery(variables?: TransactionPriceQueryVariables) {
      return { query: TransactionPriceDocument, variables: variables }
    }
export const DeleteSubscriptionDocument = gql`
    mutation DeleteSubscription($subscriptionId: String!) {
  deleteSubscription(subscriptionId: $subscriptionId)
}
    `;
export type DeleteSubscriptionMutationFn = Apollo.MutationFunction<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;

/**
 * __useDeleteSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubscriptionMutation, { data, loading, error }] = useDeleteSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useDeleteSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>(DeleteSubscriptionDocument, options);
      }
export type DeleteSubscriptionMutationHookResult = ReturnType<typeof useDeleteSubscriptionMutation>;
export type DeleteSubscriptionMutationResult = Apollo.MutationResult<DeleteSubscriptionMutation>;
export type DeleteSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;
export const RetrySubscriptionChargeDocument = gql`
    mutation RetrySubscriptionCharge($subscriptionId: String!) {
  retrySubscriptionCharge(subscriptionId: $subscriptionId)
}
    `;
export type RetrySubscriptionChargeMutationFn = Apollo.MutationFunction<RetrySubscriptionChargeMutation, RetrySubscriptionChargeMutationVariables>;

/**
 * __useRetrySubscriptionChargeMutation__
 *
 * To run a mutation, you first call `useRetrySubscriptionChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySubscriptionChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySubscriptionChargeMutation, { data, loading, error }] = useRetrySubscriptionChargeMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useRetrySubscriptionChargeMutation(baseOptions?: Apollo.MutationHookOptions<RetrySubscriptionChargeMutation, RetrySubscriptionChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySubscriptionChargeMutation, RetrySubscriptionChargeMutationVariables>(RetrySubscriptionChargeDocument, options);
      }
export type RetrySubscriptionChargeMutationHookResult = ReturnType<typeof useRetrySubscriptionChargeMutation>;
export type RetrySubscriptionChargeMutationResult = Apollo.MutationResult<RetrySubscriptionChargeMutation>;
export type RetrySubscriptionChargeMutationOptions = Apollo.BaseMutationOptions<RetrySubscriptionChargeMutation, RetrySubscriptionChargeMutationVariables>;
export const CurrentUserDataDocument = gql`
    query CurrentUserData {
  me {
    ...FullUser
  }
  growsurfParticipant {
    id
    referralCount
    referralSource
    referralStatus
  }
  growsurfSecret
  rewardsBalance
}
    ${FullUserFragmentDoc}`;

/**
 * __useCurrentUserDataQuery__
 *
 * To run a query within a React component, call `useCurrentUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserDataQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserDataQuery, CurrentUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserDataQuery, CurrentUserDataQueryVariables>(CurrentUserDataDocument, options);
      }
export function useCurrentUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserDataQuery, CurrentUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserDataQuery, CurrentUserDataQueryVariables>(CurrentUserDataDocument, options);
        }
export type CurrentUserDataQueryHookResult = ReturnType<typeof useCurrentUserDataQuery>;
export type CurrentUserDataLazyQueryHookResult = ReturnType<typeof useCurrentUserDataLazyQuery>;
export type CurrentUserDataQueryResult = Apollo.QueryResult<CurrentUserDataQuery, CurrentUserDataQueryVariables>;
export function refetchCurrentUserDataQuery(variables?: CurrentUserDataQueryVariables) {
      return { query: CurrentUserDataDocument, variables: variables }
    }
export const CreateGrowsurfParticipantDocument = gql`
    mutation CreateGrowsurfParticipant($referrerId: String) {
  createGrowsurfParticipant(referrerId: $referrerId) {
    id
    referralCount
    referralSource
    referralStatus
  }
}
    `;
export type CreateGrowsurfParticipantMutationFn = Apollo.MutationFunction<CreateGrowsurfParticipantMutation, CreateGrowsurfParticipantMutationVariables>;

/**
 * __useCreateGrowsurfParticipantMutation__
 *
 * To run a mutation, you first call `useCreateGrowsurfParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGrowsurfParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGrowsurfParticipantMutation, { data, loading, error }] = useCreateGrowsurfParticipantMutation({
 *   variables: {
 *      referrerId: // value for 'referrerId'
 *   },
 * });
 */
export function useCreateGrowsurfParticipantMutation(baseOptions?: Apollo.MutationHookOptions<CreateGrowsurfParticipantMutation, CreateGrowsurfParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGrowsurfParticipantMutation, CreateGrowsurfParticipantMutationVariables>(CreateGrowsurfParticipantDocument, options);
      }
export type CreateGrowsurfParticipantMutationHookResult = ReturnType<typeof useCreateGrowsurfParticipantMutation>;
export type CreateGrowsurfParticipantMutationResult = Apollo.MutationResult<CreateGrowsurfParticipantMutation>;
export type CreateGrowsurfParticipantMutationOptions = Apollo.BaseMutationOptions<CreateGrowsurfParticipantMutation, CreateGrowsurfParticipantMutationVariables>;
export const RewardsBalanceDocument = gql`
    query RewardsBalance {
  rewardsBalance
}
    `;

/**
 * __useRewardsBalanceQuery__
 *
 * To run a query within a React component, call `useRewardsBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRewardsBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRewardsBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useRewardsBalanceQuery(baseOptions?: Apollo.QueryHookOptions<RewardsBalanceQuery, RewardsBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RewardsBalanceQuery, RewardsBalanceQueryVariables>(RewardsBalanceDocument, options);
      }
export function useRewardsBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RewardsBalanceQuery, RewardsBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RewardsBalanceQuery, RewardsBalanceQueryVariables>(RewardsBalanceDocument, options);
        }
export type RewardsBalanceQueryHookResult = ReturnType<typeof useRewardsBalanceQuery>;
export type RewardsBalanceLazyQueryHookResult = ReturnType<typeof useRewardsBalanceLazyQuery>;
export type RewardsBalanceQueryResult = Apollo.QueryResult<RewardsBalanceQuery, RewardsBalanceQueryVariables>;
export function refetchRewardsBalanceQuery(variables?: RewardsBalanceQueryVariables) {
      return { query: RewardsBalanceDocument, variables: variables }
    }
export const ReferralStatsDocument = gql`
    query ReferralStats {
  referralStats {
    id
    rewardsEarned
    signups
    qualifiedReferrals
  }
}
    `;

/**
 * __useReferralStatsQuery__
 *
 * To run a query within a React component, call `useReferralStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralStatsQuery(baseOptions?: Apollo.QueryHookOptions<ReferralStatsQuery, ReferralStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferralStatsQuery, ReferralStatsQueryVariables>(ReferralStatsDocument, options);
      }
export function useReferralStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferralStatsQuery, ReferralStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferralStatsQuery, ReferralStatsQueryVariables>(ReferralStatsDocument, options);
        }
export type ReferralStatsQueryHookResult = ReturnType<typeof useReferralStatsQuery>;
export type ReferralStatsLazyQueryHookResult = ReturnType<typeof useReferralStatsLazyQuery>;
export type ReferralStatsQueryResult = Apollo.QueryResult<ReferralStatsQuery, ReferralStatsQueryVariables>;
export function refetchReferralStatsQuery(variables?: ReferralStatsQueryVariables) {
      return { query: ReferralStatsDocument, variables: variables }
    }
export const UpdateCurrentUserDocument = gql`
    mutation UpdateCurrentUser($userUpdate: UpdateCurrentUserInput!) {
  updateCurrentUser(userUpdate: $userUpdate) {
    ...FullUser
  }
}
    ${FullUserFragmentDoc}`;
export type UpdateCurrentUserMutationFn = Apollo.MutationFunction<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>;

/**
 * __useUpdateCurrentUserMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserMutation, { data, loading, error }] = useUpdateCurrentUserMutation({
 *   variables: {
 *      userUpdate: // value for 'userUpdate'
 *   },
 * });
 */
export function useUpdateCurrentUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>(UpdateCurrentUserDocument, options);
      }
export type UpdateCurrentUserMutationHookResult = ReturnType<typeof useUpdateCurrentUserMutation>;
export type UpdateCurrentUserMutationResult = Apollo.MutationResult<UpdateCurrentUserMutation>;
export type UpdateCurrentUserMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>;
export const UpdateOnboardingStatusDocument = gql`
    mutation UpdateOnboardingStatus($status: OnboardingStatus!) {
  updateOnboardingStatus(status: $status) {
    ...FullUser
  }
}
    ${FullUserFragmentDoc}`;
export type UpdateOnboardingStatusMutationFn = Apollo.MutationFunction<UpdateOnboardingStatusMutation, UpdateOnboardingStatusMutationVariables>;

/**
 * __useUpdateOnboardingStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingStatusMutation, { data, loading, error }] = useUpdateOnboardingStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateOnboardingStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOnboardingStatusMutation, UpdateOnboardingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOnboardingStatusMutation, UpdateOnboardingStatusMutationVariables>(UpdateOnboardingStatusDocument, options);
      }
export type UpdateOnboardingStatusMutationHookResult = ReturnType<typeof useUpdateOnboardingStatusMutation>;
export type UpdateOnboardingStatusMutationResult = Apollo.MutationResult<UpdateOnboardingStatusMutation>;
export type UpdateOnboardingStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOnboardingStatusMutation, UpdateOnboardingStatusMutationVariables>;
export const UpdateUserTimezoneDocument = gql`
    mutation UpdateUserTimezone($timezone: String!) {
  updateUserTimezone(timezone: $timezone) {
    ...FullUser
  }
}
    ${FullUserFragmentDoc}`;
export type UpdateUserTimezoneMutationFn = Apollo.MutationFunction<UpdateUserTimezoneMutation, UpdateUserTimezoneMutationVariables>;

/**
 * __useUpdateUserTimezoneMutation__
 *
 * To run a mutation, you first call `useUpdateUserTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTimezoneMutation, { data, loading, error }] = useUpdateUserTimezoneMutation({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useUpdateUserTimezoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTimezoneMutation, UpdateUserTimezoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTimezoneMutation, UpdateUserTimezoneMutationVariables>(UpdateUserTimezoneDocument, options);
      }
export type UpdateUserTimezoneMutationHookResult = ReturnType<typeof useUpdateUserTimezoneMutation>;
export type UpdateUserTimezoneMutationResult = Apollo.MutationResult<UpdateUserTimezoneMutation>;
export type UpdateUserTimezoneMutationOptions = Apollo.BaseMutationOptions<UpdateUserTimezoneMutation, UpdateUserTimezoneMutationVariables>;
export const UpdateAppDomainDocument = gql`
    mutation UpdateAppDomain($appDomain: AppDomain!) {
  updateAppDomain(appDomain: $appDomain)
}
    `;
export type UpdateAppDomainMutationFn = Apollo.MutationFunction<UpdateAppDomainMutation, UpdateAppDomainMutationVariables>;

/**
 * __useUpdateAppDomainMutation__
 *
 * To run a mutation, you first call `useUpdateAppDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppDomainMutation, { data, loading, error }] = useUpdateAppDomainMutation({
 *   variables: {
 *      appDomain: // value for 'appDomain'
 *   },
 * });
 */
export function useUpdateAppDomainMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppDomainMutation, UpdateAppDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppDomainMutation, UpdateAppDomainMutationVariables>(UpdateAppDomainDocument, options);
      }
export type UpdateAppDomainMutationHookResult = ReturnType<typeof useUpdateAppDomainMutation>;
export type UpdateAppDomainMutationResult = Apollo.MutationResult<UpdateAppDomainMutation>;
export type UpdateAppDomainMutationOptions = Apollo.BaseMutationOptions<UpdateAppDomainMutation, UpdateAppDomainMutationVariables>;
export const UpdateAttributionSourceDocument = gql`
    mutation UpdateAttributionSource($attributionSource: String!) {
  updateAttributionSource(attributionSource: $attributionSource) {
    ...FullUser
  }
}
    ${FullUserFragmentDoc}`;
export type UpdateAttributionSourceMutationFn = Apollo.MutationFunction<UpdateAttributionSourceMutation, UpdateAttributionSourceMutationVariables>;

/**
 * __useUpdateAttributionSourceMutation__
 *
 * To run a mutation, you first call `useUpdateAttributionSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttributionSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttributionSourceMutation, { data, loading, error }] = useUpdateAttributionSourceMutation({
 *   variables: {
 *      attributionSource: // value for 'attributionSource'
 *   },
 * });
 */
export function useUpdateAttributionSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttributionSourceMutation, UpdateAttributionSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttributionSourceMutation, UpdateAttributionSourceMutationVariables>(UpdateAttributionSourceDocument, options);
      }
export type UpdateAttributionSourceMutationHookResult = ReturnType<typeof useUpdateAttributionSourceMutation>;
export type UpdateAttributionSourceMutationResult = Apollo.MutationResult<UpdateAttributionSourceMutation>;
export type UpdateAttributionSourceMutationOptions = Apollo.BaseMutationOptions<UpdateAttributionSourceMutation, UpdateAttributionSourceMutationVariables>;
export const AddAssociatedWalletDocument = gql`
    mutation AddAssociatedWallet($address: String!) {
  addAssociatedWallet(address: $address)
}
    `;
export type AddAssociatedWalletMutationFn = Apollo.MutationFunction<AddAssociatedWalletMutation, AddAssociatedWalletMutationVariables>;

/**
 * __useAddAssociatedWalletMutation__
 *
 * To run a mutation, you first call `useAddAssociatedWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssociatedWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssociatedWalletMutation, { data, loading, error }] = useAddAssociatedWalletMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useAddAssociatedWalletMutation(baseOptions?: Apollo.MutationHookOptions<AddAssociatedWalletMutation, AddAssociatedWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAssociatedWalletMutation, AddAssociatedWalletMutationVariables>(AddAssociatedWalletDocument, options);
      }
export type AddAssociatedWalletMutationHookResult = ReturnType<typeof useAddAssociatedWalletMutation>;
export type AddAssociatedWalletMutationResult = Apollo.MutationResult<AddAssociatedWalletMutation>;
export type AddAssociatedWalletMutationOptions = Apollo.BaseMutationOptions<AddAssociatedWalletMutation, AddAssociatedWalletMutationVariables>;
export const AddAffiliateReferralCodeDocument = gql`
    mutation AddAffiliateReferralCode($referralCode: String!) {
  addAffiliateReferralCode(referralCode: $referralCode)
}
    `;
export type AddAffiliateReferralCodeMutationFn = Apollo.MutationFunction<AddAffiliateReferralCodeMutation, AddAffiliateReferralCodeMutationVariables>;

/**
 * __useAddAffiliateReferralCodeMutation__
 *
 * To run a mutation, you first call `useAddAffiliateReferralCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAffiliateReferralCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAffiliateReferralCodeMutation, { data, loading, error }] = useAddAffiliateReferralCodeMutation({
 *   variables: {
 *      referralCode: // value for 'referralCode'
 *   },
 * });
 */
export function useAddAffiliateReferralCodeMutation(baseOptions?: Apollo.MutationHookOptions<AddAffiliateReferralCodeMutation, AddAffiliateReferralCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAffiliateReferralCodeMutation, AddAffiliateReferralCodeMutationVariables>(AddAffiliateReferralCodeDocument, options);
      }
export type AddAffiliateReferralCodeMutationHookResult = ReturnType<typeof useAddAffiliateReferralCodeMutation>;
export type AddAffiliateReferralCodeMutationResult = Apollo.MutationResult<AddAffiliateReferralCodeMutation>;
export type AddAffiliateReferralCodeMutationOptions = Apollo.BaseMutationOptions<AddAffiliateReferralCodeMutation, AddAffiliateReferralCodeMutationVariables>;
export const KycStatusSetUserCompletedDocument = gql`
    mutation KycStatusSetUserCompleted {
  kycStatusSetUserCompleted {
    ...KycStatusBrief
  }
}
    ${KycStatusBriefFragmentDoc}`;
export type KycStatusSetUserCompletedMutationFn = Apollo.MutationFunction<KycStatusSetUserCompletedMutation, KycStatusSetUserCompletedMutationVariables>;

/**
 * __useKycStatusSetUserCompletedMutation__
 *
 * To run a mutation, you first call `useKycStatusSetUserCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKycStatusSetUserCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kycStatusSetUserCompletedMutation, { data, loading, error }] = useKycStatusSetUserCompletedMutation({
 *   variables: {
 *   },
 * });
 */
export function useKycStatusSetUserCompletedMutation(baseOptions?: Apollo.MutationHookOptions<KycStatusSetUserCompletedMutation, KycStatusSetUserCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KycStatusSetUserCompletedMutation, KycStatusSetUserCompletedMutationVariables>(KycStatusSetUserCompletedDocument, options);
      }
export type KycStatusSetUserCompletedMutationHookResult = ReturnType<typeof useKycStatusSetUserCompletedMutation>;
export type KycStatusSetUserCompletedMutationResult = Apollo.MutationResult<KycStatusSetUserCompletedMutation>;
export type KycStatusSetUserCompletedMutationOptions = Apollo.BaseMutationOptions<KycStatusSetUserCompletedMutation, KycStatusSetUserCompletedMutationVariables>;
export const UpdateMethodfiSsnDocument = gql`
    mutation UpdateMethodfiSSN($ssn: String!) {
  methodFiUpdateSSN(ssn: $ssn) {
    ...FullMethodFiEntity
  }
}
    ${FullMethodFiEntityFragmentDoc}`;
export type UpdateMethodfiSsnMutationFn = Apollo.MutationFunction<UpdateMethodfiSsnMutation, UpdateMethodfiSsnMutationVariables>;

/**
 * __useUpdateMethodfiSsnMutation__
 *
 * To run a mutation, you first call `useUpdateMethodfiSsnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMethodfiSsnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMethodfiSsnMutation, { data, loading, error }] = useUpdateMethodfiSsnMutation({
 *   variables: {
 *      ssn: // value for 'ssn'
 *   },
 * });
 */
export function useUpdateMethodfiSsnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMethodfiSsnMutation, UpdateMethodfiSsnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMethodfiSsnMutation, UpdateMethodfiSsnMutationVariables>(UpdateMethodfiSsnDocument, options);
      }
export type UpdateMethodfiSsnMutationHookResult = ReturnType<typeof useUpdateMethodfiSsnMutation>;
export type UpdateMethodfiSsnMutationResult = Apollo.MutationResult<UpdateMethodfiSsnMutation>;
export type UpdateMethodfiSsnMutationOptions = Apollo.BaseMutationOptions<UpdateMethodfiSsnMutation, UpdateMethodfiSsnMutationVariables>;
export const VerificationDataDocument = gql`
    query VerificationData {
  me {
    id
    email
    kycStatus {
      ...KycStatusBrief
    }
    methodFiEntity {
      ...FullMethodFiEntity
    }
  }
}
    ${KycStatusBriefFragmentDoc}
${FullMethodFiEntityFragmentDoc}`;

/**
 * __useVerificationDataQuery__
 *
 * To run a query within a React component, call `useVerificationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerificationDataQuery(baseOptions?: Apollo.QueryHookOptions<VerificationDataQuery, VerificationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerificationDataQuery, VerificationDataQueryVariables>(VerificationDataDocument, options);
      }
export function useVerificationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerificationDataQuery, VerificationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerificationDataQuery, VerificationDataQueryVariables>(VerificationDataDocument, options);
        }
export type VerificationDataQueryHookResult = ReturnType<typeof useVerificationDataQuery>;
export type VerificationDataLazyQueryHookResult = ReturnType<typeof useVerificationDataLazyQuery>;
export type VerificationDataQueryResult = Apollo.QueryResult<VerificationDataQuery, VerificationDataQueryVariables>;
export function refetchVerificationDataQuery(variables?: VerificationDataQueryVariables) {
      return { query: VerificationDataDocument, variables: variables }
    }